<ion-header>
  <ion-toolbar color="tertiary">
    <ion-buttons slot="start">
      <ion-button (click)="close()" color="light">
        <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title color="light">
      ¿Cómo funciona
      <span translate> game.{{ gameType }}-{{ type }}</span
      >?
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid fixed class="grid-container">
    <ion-row>
      <ion-col size="12">
        <ion-card>
          <div [ngSwitch]="gameType">
            <!-- SORTEO -->
            <ion-grid *ngSwitchCase="'sorteo'" [ngSwitch]="type" fixed>
              <!-- Navidad -->
              <ion-row *ngSwitchCase="'gordito'">
                <ion-col size="12">
                  <div class="col-md-12">
                    <h3>¿Qué es el Sorteo Gordo de Navidad?</h3>
                    <p>
                      El <b>Sorteo Gordo de Navidad </b>se celebra una vez al año, los 24 de diciembre y participan
                      80,000 números (billetes) que van del 00001 al 80,000.
                    </p>
                    <h3>¿Cuánto vale un cachito?</h3>
                    <ul>
                      <li>
                        <p>Un cachito del Sorteo Gordo de Navidad tiene un costo de 120 pesos.</p>
                      </li>
                      <li>
                        <p>El costo de una serie (20 cachitos) del Sorteo Gordo de Navidad es de 2 mil 400 pesos.</p>
                      </li>
                      <li>
                        <p>El costo de dos series (40 cachitos) del Sorteo Gordo de Navidad es de 4 mil 800 pesos.</p>
                      </li>
                      <li>
                        <p>El costo de tres series (60 cachitos) del Sorteo Gordo de Navidad es de 7 mil 200 pesos.</p>
                      </li>
                      <li>
                        <p>
                          El costo de las cuatro series (80 cachitos) del Sorteo Gordo de Navidad es de 9 mil 600 pesos.
                        </p>
                      </li>
                    </ul>
                    <h3>¿Cuánto puedo ganar con el Sorteo Gordo de Navidad?</h3>
                    <p>En el sorteo mayor 1 de cada 5 gana.</p>
                    <ul>
                      <li>
                        <p>
                          Si adquiriste las <b>cuatro series</b> del Sorteo Gordo de Navidad puedes ganar el total
                          <b>PREMIO MAYOR de 204 MILLONES de pesos</b>.
                        </p>
                      </li>
                      <li>
                        <p>
                          Si adquiriste <b>tres series</b> del Sorteo Gordo de Navidad
                          <b>puedes ganar hasta 153 millones de pesos</b>.
                        </p>
                      </li>
                      <li>
                        <p>
                          Si adquiriste <b>dos series</b> del Sorteo Gordo de Navidad
                          <b>puedes ganar hasta 102 millones de pesos</b>.
                        </p>
                      </li>
                      <li>
                        <p>
                          Si adquiriste <b>una serie</b> del Sorteo Gordo de
                          <b>puedes ganar hasta 51 millones de pesos</b>.
                        </p>
                      </li>
                      <li>
                        <p>
                          Si adquiriste un <b>Cachito</b> del Sorteo Gordo de
                          <b>puedes ganar hasta 2 millones 550 mil pesos</b>.
                        </p>
                      </li>
                    </ul>
                    <h3>Tipos de premios</h3>
                    <ol>
                      <li>
                        <h5>PREMIOS DIRECTOS</h5>
                        <p>Son los números que cantan los niños gritones durante la celebración del sorteo.</p>
                        <p>En el Sorteo Gordo de Navidad se entregan 526 premios directos.</p>
                        <p>Mismos que se reparten de la siguiente manera:</p>
                        <div class="table-responsive">
                          <table
                            class="table table-bordered table-condensed table-striped text-center"
                            style="margin: auto"
                          >
                            <thead>
                              <tr>
                                <th>CANTIDAD DE PREMIOS</th>
                                <th>PREMIOS POR SERIE</th>
                                <th>PREMIO POR CUATRO SERIES</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td><b>1</b></td>
                                <td><b>PREMIO MAYOR</b> <br />$51 MILLONES</td>
                                <td><b>PREMIO MAYOR</b><br />$204 MILLONES</td>
                              </tr>
                              <tr>
                                <td><b>1</b></td>
                                <td><b>SEGUNDO PREMIO</b><br />$3 MILLONES 200 MIL</td>
                                <td><b>SEGUNDO PREMIO</b><br />$12 MILLONES 800 MIL PESOS</td>
                              </tr>
                              <tr>
                                <td><b>4</b></td>
                                <td>$200 MIL</td>
                                <td>$800 MIL</td>
                              </tr>
                              <tr>
                                <td><b>10</b></td>
                                <td>$100 MIL</td>
                                <td>$400 MIL</td>
                              </tr>
                              <tr>
                                <td><b>20</b></td>
                                <td>$60 MIL</td>
                                <td>$240 MIL</td>
                              </tr>
                              <tr>
                                <td><b>30</b></td>
                                <td>$20 MIL</td>
                                <td>$80 MIL</td>
                              </tr>
                              <tr>
                                <td><b>30</b></td>
                                <td>$16 MIL</td>
                                <td>$64 MIL</td>
                              </tr>
                              <tr>
                                <td><b>30</b></td>
                                <td>$14 MIL</td>
                                <td>$56 MIL</td>
                              </tr>
                              <tr>
                                <td><b>400</b></td>
                                <td>$12 MIL</td>
                                <td>$48 MIL</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </li>
                      <li>
                        <h5>PREMIOS POR APROXIMACIÓN</h5>
                        <p>
                          Son los 99 números que pertenecen a la misma centena de los números ganadores de los tres
                          premios principales.
                        </p>
                        <p>En el Sorteo se reparten 198 premios por aproximación de la siguiente manera:</p>
                        <div class="table-responsive">
                          <table class="display table table-bordered text-center">
                            <thead class="align-middle">
                              <tr>
                                <th>CANTIDAD DE PREMIOS</th>
                                <th>NÚMERO DE PREMIOS POR APROXIMACIÓN</th>
                                <th>MONTO</th>
                              </tr>
                            </thead>
                            <tbody class="align-middle">
                              <tr>
                                <td rowspan="2"><b>99</b></td>
                                <td><b>2</b></td>
                                <td>
                                  <b>100 mil pesos</b><br />cada una, a los números anterior y posterior del premio
                                  mayor
                                </td>
                              </tr>
                              <tr>
                                <td><b>97</b></td>
                                <td>
                                  <b>8 mil pesos</b><br />cada una, para los números comprendidos en la centena del
                                  número del premio mayor
                                </td>
                              </tr>
                              <tr>
                                <td rowspan="2"><b>99</b></td>
                                <td><b>2</b></td>
                                <td>
                                  <b>50 mil pesos</b><br />Cada una, a los números anterior y posterior del segundo
                                  premio
                                </td>
                              </tr>
                              <tr>
                                <td><b>97</b></td>
                                <td>
                                  <b>6 mil pesos</b><br />cada una, para los números comprendidos en la centena del
                                  número del segundo premio
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <p><b>*Tabla de premios por serie</b></p>
                      </li>
                      <li>
                        <h5>PREMIOS POR TERMINACIÓN</h5>
                        <p>
                          Son los números cuyas últimas 4, 3 o 2 cifras son iguales a los números que ganaron los dos
                          premios principales del sorteo.
                        </p>
                        <p>
                          En el Sorteo se entregan en <b>806 premios por terminación</b> repartidos de la siguiente
                          manera:
                        </p>
                        <table class="display table table-bordered text-center">
                          <thead class="align-middle">
                            <tr>
                              <th>CANTIDAD DE PREMIOS</th>
                              <th>MONTO</th>
                            </tr>
                          </thead>
                          <tbody class="align-middle">
                            <tr>
                              <td><b>7</b></td>
                              <td>
                                <b>100 mil pesos</b><br />para los números cuyas cuatro últimas cifras sean iguales a
                                las cuatro últimas del premio mayor
                              </td>
                            </tr>
                            <tr>
                              <td><b>7</b></td>
                              <td>
                                <b>50 mil pesos</b><br />para los números cuyas cuatro últimas cifras sean iguales a las
                                cuatro últimas del segundo premio.
                              </td>
                            </tr>
                            <tr>
                              <td><b>72</b></td>
                              <td>
                                <b>8 mil pesos</b><br />para los números cuyas tres últimas cifras sean iguales a las
                                tres últimas del premio mayor.
                              </td>
                            </tr>
                            <tr>
                              <td><b>720</b></td>
                              <td>
                                <b>6 mil pesos</b><br />para los números cuyas dos últimas cifras sean iguales a las dos
                                últimas del premio mayor.
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <p><b>*Tabla de premios por serie</b></p>
                        <p>En la lista de premios puedes identificar los premios por terminación con la letra “t”</p>
                      </li>
                      <li>
                        <h5>REINTEGROS</h5>
                        <p>
                          El reintegro se determina si el último dígito es igual al último dígito del premio mayor,
                          segundo y tercer premio
                        </p>
                        <p>En cada Sorteo se reparten 15,192 reintegros de la siguiente manera:</p>
                        <ul>
                          <li>
                            <p>7,200 Reintegros por la última cifra del premio mayor.</p>
                          </li>
                          <li>
                            <p>7,992 Reintegros por la última cifra del segundo premio</p>
                          </li>
                        </ul>
                      </li>
                    </ol>
                    <h3>¿Qué debo considerar?</h3>
                    <p>
                      Un lote aleatorio de números de este sorteo se encuentra a la venta exclusivamente a través de
                      Medios Electrónicos.
                    </p>
                    <h3>Cómo saber si gané</h3>
                    <h5>A) Lista de Premios</h5>
                    <p>
                      La forma más común de revisar si fuiste ganador es a través de la lista de premios, misma que
                      podrás encontrar en los expendios de Lotería Nacional al día siguiente del sorteo, así como
                      también podrás consultarla de manera virtual en el
                      <a href="../../Mascarillas/ListasPremios">siguiente enlace</a>.
                    </p>
                    <h5>B) Verificador de cachitos</h5>
                    <p>
                      Esta es una herramienta sencilla, solo tienes que llenar la información solicitada en el siguiente
                      enlace. <a href="../../Home/BuscadorBoleto">verificador de premios</a>
                    </p>
                    <h5>C) Redes Sociales</h5>
                    <p>
                      Síguenos en nuestras redes sociales oficiales, ahí publicamos diariamente los resultados de todos
                      nuestros sorteos.
                    </p>
                  </div>
                </ion-col>
              </ion-row>
              <!-- Zodiaco -->
              <ion-row *ngSwitchCase="'zodiaco'">
                <ion-col size="12">
                  <div class="col-md-12">
                    <h3>¿Qué es el Sorteo Zodiaco?</h3>
                    <p>
                      El Sorteo Zodiaco se celebra los días domingo de cada semana y participan 120,000 números o
                      billetes que van del 00000 al 9999, por cada uno de los 12 signos del zodiaco y se juega en 1
                      serie.
                    </p>
                    <h3>¿Cuánto vale un cachito?</h3>
                    <ul>
                      <li>
                        <p>Un <b>Cachito</b> del Sorteo Zodiaco tiene un costo de <b>20 pesos</b>.</p>
                      </li>
                      <li>
                        <p>El costo de <b>una serie</b> (20 cachitos) del Sorteo Zodiaco es de <b>400 pesos</b>.</p>
                      </li>
                    </ul>
                    <h3>¿Cuánto puedo ganar con el Sorteo Zodiaco?</h3>
                    <p>En el Sorteo Zodiaco 1 de cada 5 gana.</p>
                    <ul>
                      <li>
                        <p>
                          Si adquiriste la <b>serie</b> del Sorteo Zodiaco
                          <b>puedes ganar el monto total del PREMIO MAYOR de $7 MILLONES DE PESOS</b>.
                        </p>
                      </li>
                      <li>
                        <p>
                          Si adquiriste un <b>Cachito</b> del Sorteo Zodiaco
                          <b>puedes ganar es hasta $350 MIL PESOS</b>.
                        </p>
                      </li>
                    </ul>
                    <h3>Tipos de premios</h3>
                    <ol>
                      <li>
                        <h5>PREMIOS DIRECTOS:</h5>
                        <p>Son los números que cantan los niños gritones durante la celebración del sorteo.</p>
                        <p>
                          En el Sorteo Zodiaco se entregan
                          <b>600</b> premios directos.
                        </p>
                        <p><b>Mismos que se reparten de la siguiente manera: Premios por cada serie</b></p>
                        <div class="table-responsive">
                          <table
                            class="table table-bordered table-condensed table-striped text-center"
                            style="margin: auto"
                          >
                            <thead>
                              <tr>
                                <th>CANTIDAD DE PREMIOS</th>
                                <th>PREMIOS POR SERIE</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td><b>1</b></td>
                                <td><b>PREMIO MAYOR</b> <br />$ 7 MILLONES</td>
                              </tr>
                              <tr>
                                <td><b>2</b></td>
                                <td><b>SEGUNDO PREMIO</b><br />$ 1.1 MILLONES</td>
                              </tr>
                              <tr>
                                <td><b>2</b></td>
                                <td>$ 176 MIL</td>
                              </tr>
                              <tr>
                                <td><b>2</b></td>
                                <td>$ 88 MIL</td>
                              </tr>
                              <tr>
                                <td><b>2</b></td>
                                <td>$ 52 MIL 800</td>
                              </tr>
                              <tr>
                                <td><b>3</b></td>
                                <td>$ 44 MIL</td>
                              </tr>
                              <tr>
                                <td><b>3</b></td>
                                <td>$ 35 MIL 200</td>
                              </tr>
                              <tr>
                                <td><b>4</b></td>
                                <td>$ 26 MIL 400</td>
                              </tr>
                              <tr>
                                <td><b>4</b></td>
                                <td>$ 17 MIL 600</td>
                              </tr>
                              <tr>
                                <td><b>4</b></td>
                                <td>$ 13 MIL 200</td>
                              </tr>
                              <tr>
                                <td><b>4</b></td>
                                <td>$ 8 MIL 800</td>
                              </tr>
                              <tr>
                                <td><b>50</b></td>
                                <td>$ 4 MIL 400</td>
                              </tr>
                              <tr>
                                <td><b>517</b></td>
                                <td>$ 2 MIL 200</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <br />
                        <p>
                          *Para mayor información, consulta el
                          <a href="../../Billete/CalendarioSorteos">Calendario de Concursos y Sorteos</a>
                        </p>
                      </li>
                      <li>
                        <h5>PREMIOS POR APROXIMACIÓN</h5>
                        <p>
                          En el <b>Sorteo Zodiaco</b> se reparten <b>198 premios por aproximación</b> de la siguiente
                          manera:
                        </p>
                        <div class="table-responsive">
                          <table class="display table table-bordered text-center">
                            <thead class="align-middle">
                              <tr>
                                <th>CANTIDAD DE PREMIOS</th>
                                <th>NÚMERO DE PREMIOS POR APROXIMACIÓN</th>
                                <th>MONTO</th>
                              </tr>
                            </thead>
                            <tbody class="align-middle">
                              <tr>
                                <td rowspan="2"><b>24</b></td>
                                <td><b>2</b></td>
                                <td>
                                  <b>44 mil pesos</b><br />cada uno, a los números anterior y posterior del premio mayor
                                </td>
                              </tr>
                              <tr>
                                <td><b>22</b></td>
                                <td>
                                  <b>22 mil pesos</b><br />cada una, para las cuatro cifras anterior y posterior del
                                  premio mayor con cualquier signo del zodiaco, excluyendo al del premio mayor y a los
                                  números anterior y posterior.
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <p>*Tabla de premios por serie</p>
                      </li>
                      <li>
                        <h5>PREMIOS POR TERMINACIÓN</h5>
                        <p>En los sorteo Zodiaco se entrega un total de 1,199 premios por terminaciones</p>
                        <table class="display table table-bordered text-center">
                          <thead class="align-middle">
                            <tr>
                              <th>CANTIDAD DE PREMIOS</th>
                              <th>MONTO</th>
                            </tr>
                          </thead>
                          <tbody class="align-middle">
                            <tr>
                              <td><b>11</b></td>
                              <td>
                                <b>44 mil pesos</b><br />para los números cuyas cuatro últimas cifras sean iguales a las
                                cuatro últimas del premio mayor, con cualquier signo del zodiaco, menos el premiado
                              </td>
                            </tr>
                            <tr>
                              <td><b>108</b></td>
                              <td>
                                <b>4 mil 400 pesos</b><br />para los números cuyas tres últimas cifras sean iguales a
                                las tres últimas del premio mayor, con cualquier signo del zodiaco
                              </td>
                            </tr>
                            <tr>
                              <td><b>1080</b></td>
                              <td>
                                <b>2 mil 200 pesos</b><br />para los números cuyas dos últimas cifras sean iguales a las
                                dos últimas del premio mayor, con cualquier signo del zodiaco
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <p>*Tabla de premios por serie</p>
                      </li>
                      <li>
                        <h5>REINTEGROS</h5>
                        <p>El Sorteo Zodiaco entrega un total de 20,799 reintegros de la siguiente manera:</p>
                        <ul>
                          <li>
                            <p>
                              10, 800 a los números que terminen con el mismo número del premio mayor, con cualquier
                              signo del zodiaco con excepción de los boletos ya premiados
                            </p>
                          </li>
                          <li>
                            <p>9,999 a los cachitos del mismo signo del premio mayor.</p>
                          </li>
                        </ul>
                      </li>
                    </ol>
                    <h3>¿Qué debo considerar?</h3>
                    <p>
                      Un lote aleatorio de números de este sorteo se encuentra a la venta exclusivamente a través de
                      Medios Electrónicos.
                    </p>
                    <h3>Cómo saber si gané</h3>
                    <h5>A) Lista de Premios</h5>
                    <p>
                      La forma más común de revisar si fuiste ganador es a través de la lista de premios, misma que
                      podrás encontrar en los expendios de Lotería Nacional al día siguiente del sorteo, así como
                      también podrás consultarla de manera virtual en el
                      <a href="../../Mascarillas/ListasPremios">siguiente enlace</a>.
                    </p>
                    <h5>B) Verificador de cachitos</h5>
                    <p>
                      Esta es una herramienta sencilla, solo tienes que llenar la información solicitada en el siguiente
                      enlace. <a href="../../Home/BuscadorBoleto">verificador de premios</a>
                    </p>
                    <h5>C) Redes Sociales</h5>
                    <p>
                      Síguenos en nuestras redes sociales oficiales, ahí publicamos diariamente los resultados de todos
                      nuestros sorteos.
                    </p>
                  </div>
                </ion-col>
              </ion-row>
              <!-- Zodiaco Especial -->
              <ion-row *ngSwitchCase="'zodiaco-especial'">
                <ion-col size="12">
                  <div class="col-md-12">
                    <h3>¿Qué es el Sorteo Zodiaco Especial?</h3>
                    <p>
                      El Sorteo Zodiaco Especial se celebra un domingo al mes y participan 120,000 números o billetes
                      numerados del 00000 al 9999, por cada uno de los 12 signos del zodiaco.
                    </p>
                    <p>
                      Se lleva a cabo en 1 Serie y ofrece un total de 43 MILLONES 384 MIL 300 pesos repartidos en 22,622
                      premios en efectivo.
                    </p>
                    <h3>¿Cuánto vale un cachito?</h3>
                    <ul>
                      <li>
                        <p>Un <b>Cachito</b> del Sorteo Zodiaco Esoecial tiene un costo de <b>35 pesos</b>.</p>
                      </li>
                      <li>
                        <p>
                          El costo de <b>una serie</b> (20 cachitos) del Sorteo Zodiaco Especial es de <b>700 pesos</b>.
                        </p>
                      </li>
                    </ul>
                    <h3>¿Cuánto puedo ganar con el Sorteo Zodiaco Especial?</h3>
                    <p>En el Sorteo Zodiaco Especial 1 de cada 5 gana.</p>
                    <ul>
                      <li>
                        <p>
                          Si adquiriste una <b>serie</b> del Sorteo Zodiaco Especial
                          <b>puedes ganar el monto total del PREMIO MAYOR de $11 MILLONES DE PESOS</b>.
                        </p>
                      </li>
                      <li>
                        <p>
                          Si adquiriste un <b>Cachito</b> del Sorteo Zodiaco Especial
                          <b>puedes ganar es hasta $550 MIL PESOS</b>.
                        </p>
                      </li>
                    </ul>
                    <h3>Tipos de premios</h3>
                    <ol>
                      <li>
                        <h5>PREMIOS DIRECTOS:</h5>
                        <p>Son los números que cantan los niños gritones durante la celebración del sorteo.</p>
                        <p>
                          En el Sorteo Zodiaco Especial se entregan
                          <b>600</b> premios directos.
                        </p>
                        <p><b>Mismos que se reparten de la siguiente manera: Premios por cada serie</b></p>
                        <div class="table-responsive">
                          <table
                            class="table table-bordered table-condensed table-striped text-center"
                            style="margin: auto"
                          >
                            <thead>
                              <tr>
                                <th>CANTIDAD DE PREMIOS</th>
                                <th>PREMIOS POR SERIE</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td><b>1</b></td>
                                <td><b>PREMIO MAYOR</b> <br />$ 11 MILLONES</td>
                              </tr>
                              <tr>
                                <td><b>2</b></td>
                                <td><b>SEGUNDO PREMIO</b><br />$ 1.5 MILLONES</td>
                              </tr>
                              <tr>
                                <td><b>2</b></td>
                                <td>$ 400 MIL</td>
                              </tr>
                              <tr>
                                <td><b>2</b></td>
                                <td>$ 200 MIL</td>
                              </tr>
                              <tr>
                                <td><b>2</b></td>
                                <td>$ 140 MIL 800</td>
                              </tr>
                              <tr>
                                <td><b>2</b></td>
                                <td>$ 120 MIL</td>
                              </tr>
                              <tr>
                                <td><b>3</b></td>
                                <td>$ 100 MIL</td>
                              </tr>
                              <tr>
                                <td><b>3</b></td>
                                <td>$ 80 MIL</td>
                              </tr>
                              <tr>
                                <td><b>4</b></td>
                                <td>$ 60 MIL</td>
                              </tr>
                              <tr>
                                <td><b>4</b></td>
                                <td>$ 40 MIL</td>
                              </tr>
                              <tr>
                                <td><b>4</b></td>
                                <td>$ 30 MIL</td>
                              </tr>
                              <tr>
                                <td><b>4</b></td>
                                <td>$ 20 MIL</td>
                              </tr>
                              <tr>
                                <td><b>50</b></td>
                                <td>$ 10 MIL</td>
                              </tr>
                              <tr>
                                <td><b>517</b></td>
                                <td>$ 5 MIL</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <br />
                        <p>
                          *Para mayor información, consulta el
                          <a href="../../Billete/CalendarioSorteos">Calendario de Concursos y Sorteos</a>
                        </p>
                      </li>
                      <li>
                        <h5>PREMIOS POR APROXIMACIÓN</h5>
                        <p>
                          En los sorteos de <b>Zodiaco Especial</b> se entrega en total <b>24 por aproximación</b> de la
                          siguiente manera:
                        </p>
                        <div class="table-responsive">
                          <table class="display table table-bordered text-center">
                            <thead class="align-middle">
                              <tr>
                                <th>CANTIDAD DE PREMIOS</th>
                                <th>NÚMERO DE PREMIOS POR APROXIMACIÓN</th>
                                <th>MONTO</th>
                              </tr>
                            </thead>
                            <tbody class="align-middle">
                              <tr>
                                <td rowspan="2"><b>24</b></td>
                                <td><b>2</b></td>
                                <td>
                                  <b>100 mil pesos</b><br />cada uno, a los números anterior y posterior del premio
                                  mayor
                                </td>
                              </tr>
                              <tr>
                                <td><b>22</b></td>
                                <td>
                                  <b>50 mil pesos</b><br />cada una, para las cuatro cifras anterior y posterior del
                                  premio mayor con cualquier signo del zodiaco, excluyendo al del premio mayor y a los
                                  números anterior y posterior.
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <p>*Tabla de premios por serie</p>
                      </li>
                      <li>
                        <h5>PREMIOS POR TERMINACIÓN</h5>
                        <p>En los sorteo Zodiaco Especial se entrega un total de 1,199 premios por terminaciones</p>
                        <table class="display table table-bordered text-center">
                          <thead class="align-middle">
                            <tr>
                              <th>CANTIDAD DE PREMIOS</th>
                              <th>MONTO</th>
                            </tr>
                          </thead>
                          <tbody class="align-middle">
                            <tr>
                              <td><b>11</b></td>
                              <td>
                                <b>100 mil pesos</b><br />para los números cuyas cuatro últimas cifras sean iguales a
                                las cuatro últimas del premio mayor, con cualquier signo del zodiaco, menos el premiado
                              </td>
                            </tr>
                            <tr>
                              <td><b>108</b></td>
                              <td>
                                <b>10 mil pesos</b><br />para los números cuyas tres últimas cifras sean iguales a las
                                tres últimas del premio mayor, con cualquier signo del zodiaco
                              </td>
                            </tr>
                            <tr>
                              <td><b>1080</b></td>
                              <td>
                                <b>5 mil pesos</b><br />Para los números cuyas dos últimas cifras sean iguales a las dos
                                últimas del premio mayor, con cualquier signo del zodiaco (excluyendo las cuatro y tres
                                cifras)
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <p>*Tabla de premios por serie</p>
                        <p>En la lista de premios puedes identificar los premios por terminación con la letra “t”</p>
                      </li>
                      <li>
                        <h5>REINTEGROS</h5>
                        <p>El Sorteo Zodiaco Especial entrega un total de 20,799 reintegros de la siguiente manera:</p>
                        <ul>
                          <li>
                            <p>
                              10, 800 a los números que terminen con el mismo número del premio mayor, con cualquier
                              signo del zodiaco con excepción de los boletos ya premiados
                            </p>
                          </li>
                          <li>
                            <p>9,999 a los cachitos del mismo signo del premio mayor.</p>
                          </li>
                        </ul>
                      </li>
                    </ol>
                    <h3>¿Qué debo considerar?</h3>
                    <p>
                      Un lote aleatorio de números de este sorteo se encuentra a la venta exclusivamente a través de
                      Medios Electrónicos.
                    </p>
                    <h3>Cómo saber si gané</h3>
                    <h5>A) Lista de Premios</h5>
                    <p>
                      La forma más común de revisar si fuiste ganador es a través de la lista de premios, misma que
                      podrás encontrar en los expendios de Lotería Nacional al día siguiente del sorteo, así como
                      también podrás consultarla de manera virtual en el
                      <a href="../../Mascarillas/ListasPremios">siguiente enlace</a>.
                    </p>
                    <h5>B) Verificador de cachitos</h5>
                    <p>
                      Esta es una herramienta sencilla, solo tienes que llenar la información solicitada en el siguiente
                      enlace. <a href="../../Home/BuscadorBoleto">verificador de premios</a>
                    </p>
                    <h5>C) Redes Sociales</h5>
                    <p>
                      Síguenos en nuestras redes sociales oficiales, ahí publicamos diariamente los resultados de todos
                      nuestros sorteos.
                    </p>
                  </div>
                </ion-col>
              </ion-row>
              <!-- Especial -->
              <ion-row *ngSwitchCase="'especial'">
                <ion-col size="12">
                  <div class="col-md-12">
                    <h3>¿Qué es el Sorteo Especial?</h3>
                    <p>
                      El Sorteo Especial se celebra una vez al mes y participan 60,000 números (billetes) que van del
                      00001 al 60,000.
                    </p>
                    <p><b>*Sorteo Especial de Día de Reyes se divide en 4 series</b></p>
                    <p><b>**Sorteo Especial de Día de la Virgen se divide en 3 series</b></p>
                    <h3>¿Cuánto vale un cachito?</h3>
                    <ul>
                      <li>
                        <p>Un <b>Cachito</b> del Sorteo Especial tiene un costo de <b>60 pesos</b>.</p>
                      </li>
                      <li>
                        <p>
                          El costo de <b>una serie</b> (20 cachitos) del Sorteo Especial es de <b>1 mil 200 pesos</b>.
                        </p>
                      </li>
                      <li>
                        <p>
                          El costo de las <b>dos series</b> (40 cachitos) del Sorteo Especial es de
                          <b>2 mil 400 pesos</b>.
                        </p>
                      </li>
                    </ul>
                    <h3>¿Cuánto puedo ganar con el Sorteo Especial?</h3>
                    <p>En el Sorteo Especial 1 de cada 5 gana.</p>
                    <ul>
                      <li>
                        <p>
                          Si adquiriste las <b>dos series</b> del Sorteo Especial
                          <b>puedes ganar el monto total del PREMIO MAYOR de $27 MILLONES DE PESOS</b>.
                        </p>
                      </li>
                      <li>
                        <p>
                          Si adquiriste solo <b>una serie</b> del Sorteo Especial
                          <b>puedes ganar hasta 13.5 MILLONES DE PESOS</b>.
                        </p>
                      </li>
                      <li>
                        <p>
                          Si adquiriste un <b>Cachito</b> del Sorteo Especial
                          <b>puedes ganar es hasta $675 MIL PESOS</b>.
                        </p>
                      </li>
                    </ul>
                    <h3>Tipos de premios</h3>
                    <ol>
                      <li>
                        <h5>PREMIOS DIRECTOS:</h5>
                        <p>Son los números que cantan los niños gritones durante la celebración del sorteo.</p>
                        <p>
                          En el Sorteo Especial día de las madres y sorteo magno 31 de diciembre se entregan
                          <b>700</b> premios directos.
                        </p>
                        <p><b>Mismos que se reparten de la siguiente manera: </b></p>
                        <div class="table-responsive">
                          <table
                            class="table table-bordered table-condensed table-striped text-center"
                            style="margin: auto"
                          >
                            <thead>
                              <tr>
                                <th>CANTIDAD DE PREMIOS</th>
                                <th>PREMIOS POR SERIE</th>
                                <th>PREMIO POR DOS SERIES</th>
                                <th>PREMIOS POR TRES SERIES**</th>
                                <th>PREMIOS POR CUATRO SERIES*</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td><b>1</b></td>
                                <td><b>PREMIO MAYOR</b> <br />$ 13.5 MILLONES</td>
                                <td><b>PREMIO MAYOR</b> <br />$ 27 MILLONES</td>
                                <td><b>PREMIO MAYOR</b> <br />$ 40.5 MILLONES</td>
                                <td><b>PREMIO MAYOR</b> <br />$ 54.5 MILLONES</td>
                              </tr>
                              <tr>
                                <td><b>1</b></td>
                                <td><b>SEGUNDO PREMIO</b><br />$ 1.5 MILLONES</td>
                                <td><b>SEGUNDO PREMIO</b><br />$ 3 MILLONES</td>
                                <td><b>SEGUNDO PREMIO</b><br />$ 4.5 MILLONES</td>
                                <td><b>SEGUNDO PREMIO</b><br />$ 16 MILLONES</td>
                              </tr>
                              <tr>
                                <td><b>4</b></td>
                                <td>$ 200 MIL</td>
                                <td>$ 400 MIL</td>
                                <td>$ 600 MIL</td>
                                <td>$ 800 MIL</td>
                              </tr>
                              <tr>
                                <td><b>4</b></td>
                                <td>$ 100 MIL</td>
                                <td>$ 200 MIL</td>
                                <td>$ 300 MIL</td>
                                <td>$ 400 MIL</td>
                              </tr>
                              <tr>
                                <td><b>10</b></td>
                                <td>$ 63 MIL 500</td>
                                <td>$ 127 MIL</td>
                                <td>$ 190.5 MIL</td>
                                <td>$ 254 MIL</td>
                              </tr>
                              <tr>
                                <td><b>15</b></td>
                                <td>$ 50 MIL</td>
                                <td>$ 100 MIL</td>
                                <td>$ 150 MIL</td>
                                <td>$ 200 MIL</td>
                              </tr>
                              <tr>
                                <td><b>25</b></td>
                                <td>$ 30 MIL</td>
                                <td>$ 60 MIL</td>
                                <td>$ 90 MIL</td>
                                <td>$ 120 MIL</td>
                              </tr>
                              <tr>
                                <td><b>45</b></td>
                                <td>$ 20 MIL</td>
                                <td>$ 40 MIL</td>
                                <td>$ 60 MIL</td>
                                <td>$ 80 MIL</td>
                              </tr>
                              <tr>
                                <td><b>35</b></td>
                                <td>$ 10 MIL</td>
                                <td>$ 20 MIL</td>
                                <td>$ 30 MIL</td>
                                <td>$ 40 MIL</td>
                              </tr>
                              <tr>
                                <td><b>35</b></td>
                                <td>$ 8 MIL</td>
                                <td>$ 16 MIL</td>
                                <td>$ 24 MIL</td>
                                <td>$ 32 MIL</td>
                              </tr>
                              <tr>
                                <td><b>35</b></td>
                                <td>$ 7 MIL</td>
                                <td>$ 14 MIL</td>
                                <td>$ 21 MIL</td>
                                <td>$ 28 MIL</td>
                              </tr>
                              <tr>
                                <td><b>490</b></td>
                                <td>$ 6 MIL</td>
                                <td>$ 12 MIL</td>
                                <td>$ 18 MIL</td>
                                <td>$ 24 MIL</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <br />
                        <p>
                          *Para mayor información, consulta el
                          <a href="../../Billete/CalendarioSorteos">Calendario de Concursos y Sorteos</a>
                        </p>
                      </li>
                      <li>
                        <h5>PREMIOS POR APROXIMACIÓN</h5>
                        <p>
                          Son los 99 números que pertenecen a la misma centena de los números ganadores de los tres
                          premios principales.
                        </p>
                        <p>
                          En el <b>Sorteo Especial</b> se reparten <b>198 premios por aproximación</b> de la siguiente
                          manera:
                        </p>
                        <div class="table-responsive">
                          <table class="display table table-bordered text-center">
                            <thead class="align-middle">
                              <tr>
                                <th>CANTIDAD DE PREMIOS</th>
                                <th>NÚMERO DE PREMIOS POR APROXIMACIÓN</th>
                                <th>MONTO</th>
                              </tr>
                            </thead>
                            <tbody class="align-middle">
                              <tr>
                                <td rowspan="2"><b>99</b></td>
                                <td><b>2</b></td>
                                <td>
                                  <b>100 mil pesos</b><br />cada uno, a los números anterior y posterior del premio
                                  mayor
                                </td>
                              </tr>
                              <tr>
                                <td><b>97</b></td>
                                <td>
                                  <b>8 mil pesos</b><br />cada uno, para los números comprendidos en la centena del
                                  número del premio mayor
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <p>*Tabla de premios por serie</p>
                      </li>
                      <li>
                        <h5>PREMIOS POR TERMINACIÓN</h5>
                        <p>
                          Son los números cuyas últimas 4, 3 o 2 cifras son iguales a los números que ganaron los dos
                          premios principales del sorteo.
                        </p>
                        <p>
                          En el Sorteo Especial se entregan en <b>604 premios por terminación</b> repartidos de la
                          siguiente manera:
                        </p>
                        <table class="display table table-bordered text-center">
                          <thead class="align-middle">
                            <tr>
                              <th>CANTIDAD DE PREMIOS</th>
                              <th>MONTO</th>
                            </tr>
                          </thead>
                          <tbody class="align-middle">
                            <tr>
                              <td><b>5</b></td>
                              <td>
                                <b>100 mil pesos</b><br />para los números cuyas cuatro últimas cifras sean iguales a
                                las cuatro últimas del premio mayor
                              </td>
                            </tr>
                            <tr>
                              <td><b>5</b></td>
                              <td>
                                <b>50 mil pesos</b><br />para los números cuyas cuatro últimas cifras sean iguales a las
                                cuatro últimas del segundo premio
                              </td>
                            </tr>
                            <tr>
                              <td><b>54</b></td>
                              <td>
                                <b>10 mil pesos</b><br />para los números cuyas tres últimas cifras sean iguales a las
                                tres últimas del premio mayor
                              </td>
                            </tr>
                            <tr>
                              <td><b>540</b></td>
                              <td>
                                <b>6 mil pesos</b><br />para los números cuyas dos últimas cifras sean iguales a las dos
                                últimas del premio mayor
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <p>*Tabla de premios por serie</p>
                        <p>En la lista de premios puedes identificar los premios por terminación con la letra “t”</p>
                      </li>
                      <li>
                        <h5>REINTEGROS</h5>
                        <p>
                          El reintegro se determina si el último dígito es igual al último dígito del premio mayor,
                          segundo y tercer premio
                        </p>
                        <p>En cada Sorteo Especial se reparten 11,394 reintegros de la siguiente manera:</p>
                        <ul>
                          <li>
                            <p>5,400 Reintegros por la última cifra del premio mayor.</p>
                          </li>
                          <li>
                            <p>5,994 Reintegros por la última cifra del segundo premio</p>
                          </li>
                        </ul>
                      </li>
                    </ol>
                    <h3>¿Qué debo considerar?</h3>
                    <p>
                      Un lote aleatorio de números de este sorteo se encuentra a la venta exclusivamente a través de
                      Medios Electrónicos.
                    </p>
                    <h3>Cómo saber si gané</h3>
                    <h5>A) Lista de Premios</h5>
                    <p>
                      La forma más común de revisar si fuiste ganador es a través de la lista de premios, misma que
                      podrás encontrar en los expendios de Lotería Nacional al día siguiente del sorteo, así como
                      también podrás consultarla de manera virtual en el
                      <a href="../../Mascarillas/ListasPremios">siguiente enlace</a>.
                    </p>
                    <h5>B) Verificador de cachitos</h5>
                    <p>
                      Esta es una herramienta sencilla, solo tienes que llenar la información solicitada en el siguiente
                      enlace. <a href="../../Home/BuscadorBoleto">verificador de premios</a>
                    </p>
                    <h5>C) Redes Sociales</h5>
                    <p>
                      Síguenos en nuestras redes sociales oficiales, ahí publicamos diariamente los resultados de todos
                      nuestros sorteos.
                    </p>
                  </div>
                </ion-col>
              </ion-row>
              <!-- Magno -->
              <ion-row *ngSwitchCase="'magno'">
                <ion-col size="12">
                  <div class="col-md-12">
                    <h3>¿Qué es el Sorteo Magno?</h3>
                    <p>
                      El Sorteo Magno se celebra en algunas ocasiones especiales durante el año y participan 60 mil
                      números (billetes) que van del 00001 al 60,000.
                    </p>
                    <p><b>*Sorteo Magno Día de las Madres se divide en 3 series</b></p>
                    <p><b>***Sorteo Magno 31 diciembre se divide en 4 series</b></p>
                    <h3>¿Cuánto vale un cachito?</h3>
                    <ul>
                      <li>
                        <p>Un <b>cachito</b> del Sorteo Magno tiene un costo de <b>120 pesos</b>.</p>
                      </li>
                      <li>
                        <p>El costo de <b>una serie</b> (20 cachitos) del Sorteo Magno es de <b>2 mil 400 pesos</b>.</p>
                      </li>
                      <li>
                        <p>
                          El costo de las <b>dos series</b> (40 cachitos) del Sorteo Magno es de <b>7 mil 200 pesos</b>.
                        </p>
                      </li>
                    </ul>
                    <h3>¿Cuánto puedo ganar con el Sorteo Magno?</h3>
                    <p>En el Sorteo Magno 1 de cada 5 gana.</p>
                    <ul>
                      <li>
                        <p>
                          Si adquiriste <b>las tres</b> series del Sorteo Magno
                          <b>puedes ganar el total del premio mayor de 78 MILLONES DE PESOS</b>.
                        </p>
                      </li>
                      <li>
                        <p>
                          Si adquiriste <b>dos Series</b> del Sorteo Magno
                          <b>puedes ganar hasta 52 MILLONES DE PESOS</b>.
                        </p>
                      </li>
                      <li>
                        <p>
                          Si adquiriste <b>una serie</b> del Sorteo Magno
                          <b>puedes ganar hasta 26 MILLONES DE PESOS</b>.
                        </p>
                      </li>
                      <li>
                        <p>
                          Si adquiriste un <b>Cachito</b> del Sorteo Magno
                          <b>puedes ganar hasta 1 MILLÓN 300 MIL PESOS</b>.
                        </p>
                      </li>
                    </ul>
                    <h3>Tipos de premios</h3>
                    <ol>
                      <li>
                        <h5>Premios directos</h5>
                        <p>Son los números que cantan los niños gritones durante la celebración del sorteo.</p>
                        <p>
                          En el Sorteo Magno día de las madres y sorteo magno 31 de diciembre se entregan 760 premios
                          directos.
                        </p>
                        <p><b>Mismos que se reparten de la siguiente manera: </b></p>
                        <div class="table-responsive">
                          <table
                            class="table table-bordered table-condensed table-striped text-center"
                            style="margin: auto"
                          >
                            <thead>
                              <tr>
                                <th>CANTIDAD DE PREMIOS</th>
                                <th>PREMIOS POR UNA SERIE</th>
                                <th>PREMIO POR DOS SERIES</th>
                                <th>PREMIO POR TRES SERIES*</th>
                                <th>PREMIOS POR CUATRO SERIES***</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td><b>1</b></td>
                                <td><b>PREMIO MAYOR</b><br />$ 26 MILLONES</td>
                                <td><b>PREMIO MAYOR</b><br />$ 52 MILLONES</td>
                                <td><b>PREMIO MAYOR</b><br />$ 78 MILLONES</td>
                                <td><b>PREMIO MAYOR</b><br />$ 104 MILLONES</td>
                              </tr>
                              <tr>
                                <td><b>1</b></td>
                                <td><b>SEGUNDO PREMIO</b><br />$ 2.5 MILLONES</td>
                                <td><b>SEGUNDO PREMIO</b><br />$ 5 MILLONES</td>
                                <td><b>SEGUNDO PREMIO</b><br />$ 7.5 MILLONES</td>
                                <td><b>SEGUNDO PREMIO</b><br />$ 10 MILLONES</td>
                              </tr>
                              <tr>
                                <td><b>4</b></td>
                                <td>$ 400 MIL</td>
                                <td>$ 800 MIL</td>
                                <td>$ 1.2 MILLONES</td>
                                <td>$ 1.6 MILLONES</td>
                              </tr>
                              <tr>
                                <td><b>4</b></td>
                                <td>$ 200 MIL</td>
                                <td>$ 400 MIL</td>
                                <td>$ 600 MIL</td>
                                <td>$ 800 MIL</td>
                              </tr>
                              <tr>
                                <td><b>20</b></td>
                                <td>$ 100 MIL</td>
                                <td>$ 200 MIL</td>
                                <td>$ 300 MIL</td>
                                <td>$ 400 MIL</td>
                              </tr>
                              <tr>
                                <td><b>20</b></td>
                                <td>$ 60 MIL</td>
                                <td>$ 120 MIL</td>
                                <td>$ 180 MIL</td>
                                <td>$ 240 MIL</td>
                              </tr>
                              <tr>
                                <td><b>40</b></td>
                                <td>$ 40 MIL</td>
                                <td>$ 80 MIL</td>
                                <td>$ 120 MIL</td>
                                <td>$ 160 MIL</td>
                              </tr>
                              <tr>
                                <td><b>30</b></td>
                                <td>$ 20 MIL</td>
                                <td>$ 40 MIL</td>
                                <td>$ 60 MIL</td>
                                <td>$ 80 MIL</td>
                              </tr>
                              <tr>
                                <td><b>30</b></td>
                                <td>$ 16 MIL</td>
                                <td>$ 32 MIL</td>
                                <td>$ 48 MIL</td>
                                <td>$ 64 MIL</td>
                              </tr>
                              <tr>
                                <td><b>30</b></td>
                                <td>$ 14 MIL</td>
                                <td>$ 28 MIL</td>
                                <td>$ 42 MIL</td>
                                <td>$ 54 MIL</td>
                              </tr>
                              <tr>
                                <td><b>580</b></td>
                                <td>$ 12 MIL</td>
                                <td>$ 24 MIL</td>
                                <td>$ 36 MIL</td>
                                <td>$ 48 MIL</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <br />
                        <p>
                          *Para mayor información, consulta el
                          <a href="../../Billete/CalendarioSorteos">Calendario de Concursos y Sorteos</a>
                        </p>
                        <p>En el Sorteo Magno 30 de septiembre se entregan <b>763</b> premios directos.</p>
                        <p><b>Mismos que se reparten de la siguiente manera: </b></p>
                        <div class="table-responsive">
                          <table
                            class="table table-bordered table-condensed table-striped text-center"
                            style="margin: auto"
                          >
                            <thead>
                              <tr>
                                <th>CANTIDAD DE PREMIOS</th>
                                <th>PREMIOS POR SERIE</th>
                                <th>PREMIO POR DOS SERIES</th>
                                <th>PREMIOS POR TRES SERIES</th>
                                <th>PREMIOS POR CUATRO SERIES</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td><b>1</b></td>
                                <td><b>PREMIO MAYOR</b><br />$ 26 MILLONES</td>
                                <td><b>PREMIO MAYOR</b><br />$ 52 MILLONES</td>
                                <td><b>PREMIO MAYOR</b><br />$ 78 MILLONES</td>
                                <td><b>PREMIO MAYOR</b><br />$ 104 MILLONES</td>
                              </tr>
                              <tr>
                                <td><b>1</b></td>
                                <td><b>SEGUNDO PREMIO</b><br />$ 3 MILLONES</td>
                                <td><b>SEGUNDO PREMIO</b><br />$ 6 MILLONES</td>
                                <td><b>SEGUNDO PREMIO</b><br />$ 9 MILLONES</td>
                                <td><b>SEGUNDO PREMIO</b><br />$ 12 MILLONES</td>
                              </tr>
                              <tr>
                                <td><b>3</b></td>
                                <td><b>20</b><br />CENTENARIOS (*VALOR EN PESOS DEL CENTENARIO)</td>
                                <td><b>40</b><br />CENTENARIOS (*VALOR EN PESOS DEL CENTENARIO)</td>
                                <td><b>60</b><br />CENTENARIOS (*VALOR EN PESOS DEL CENTENARIO)</td>
                                <td><b>80</b><br />CENTENARIOS (*VALOR EN PESOS DEL CENTENARIO)</td>
                              </tr>
                              <tr>
                                <td><b>4</b></td>
                                <td>$ 500 MIL</td>
                                <td>$ 1 MILLÓN</td>
                                <td>$ 1.5 MILLONES</td>
                                <td>$ 2 MILLONES</td>
                              </tr>
                              <tr>
                                <td><b>4</b></td>
                                <td>$ 225 MIL</td>
                                <td>$ 450 MIL</td>
                                <td>$ 675 MIL</td>
                                <td>$ 900 MIL</td>
                              </tr>
                              <tr>
                                <td><b>20</b></td>
                                <td>$ 100 MIL</td>
                                <td>$ 200 MIL</td>
                                <td>$ 300 MIL</td>
                                <td>$ 400 MIL</td>
                              </tr>
                              <tr>
                                <td><b>20</b></td>
                                <td>$ 60 MIL</td>
                                <td>$ 120 MIL</td>
                                <td>$ 180 MIL</td>
                                <td>$ 240 MIL</td>
                              </tr>
                              <tr>
                                <td><b>40</b></td>
                                <td>$ 40 MIL</td>
                                <td>$ 80 MIL</td>
                                <td>$ 120 MIL</td>
                                <td>$ 160 MIL</td>
                              </tr>
                              <tr>
                                <td><b>30</b></td>
                                <td>$ 20 MIL</td>
                                <td>$ 40 MIL</td>
                                <td>$ 60 MIL</td>
                                <td>$ 80 MIL</td>
                              </tr>
                              <tr>
                                <td><b>30</b></td>
                                <td>$ 16 MIL</td>
                                <td>$ 32 MIL</td>
                                <td>$ 48 MIL</td>
                                <td>$ 64 MIL</td>
                              </tr>
                              <tr>
                                <td><b>30</b></td>
                                <td>$ 14 MIL</td>
                                <td>$ 28 MIL</td>
                                <td>$ 42 MIL</td>
                                <td>$ 56 MIL</td>
                              </tr>
                              <tr>
                                <td><b>580</b></td>
                                <td>$ 10 MIL</td>
                                <td>$ 20 MIL</td>
                                <td>$ 30 MIL</td>
                                <td>$ 40 MIL</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <br />
                        <p><b>*Consulta valor vigente del centenario el día del sorteo</b></p>
                      </li>
                      <li>
                        <h5>PREMIOS POR APROXIMACIÓN</h5>
                        <p>
                          Son los 99 números que pertenecen a la misma centena de los números ganadores de los tres
                          premios principales.
                        </p>
                        <p>
                          En el <b>Sorteo Magno</b> se reparten <b>198 premios por aproximación</b> de la siguiente
                          manera:
                        </p>
                        <div class="table-responsive">
                          <table class="display table table-bordered text-center">
                            <thead class="align-middle">
                              <tr>
                                <th>CANTIDAD DE PREMIOS</th>
                                <th>NÚMERO DE PREMIOS POR APROXIMACIÓN</th>
                                <th>MONTO</th>
                              </tr>
                            </thead>
                            <tbody class="align-middle">
                              <tr>
                                <td rowspan="2"><b>99</b></td>
                                <td><b>2</b></td>
                                <td>
                                  <b>200 mil pesos</b><br />cada uno, a los números anterior y posterior del premio
                                  mayor
                                </td>
                              </tr>
                              <tr>
                                <td><b>97</b></td>
                                <td>
                                  <b>8 mil pesos</b><br />cada uno, para los números comprendidos en la centena del
                                  número del premio mayor
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <p><b>*Tabla de premios por serie</b></p>
                        <p>En la lista de premios podrán identificarlos con la letra “c”</p>
                      </li>
                      <li>
                        <h5>PREMIOS POR TERMINACIÓN</h5>
                        <p>
                          Son los números cuyas últimas 4, 3 o 2 cifras son iguales a los números que ganaron los dos
                          premios principales del sorteo.
                        </p>
                        <p>
                          En el Sorteo Magno se entregan en <b>604 premios por terminación</b> repartidos de la
                          siguiente manera:
                        </p>
                        <table class="display table table-bordered text-center">
                          <thead class="align-middle">
                            <tr>
                              <th>CANTIDAD DE PREMIOS</th>
                              <th>MONTO</th>
                            </tr>
                          </thead>
                          <tbody class="align-middle">
                            <tr>
                              <td><b>5</b></td>
                              <td>
                                <b>200 mil pesos</b> para los números cuyas cuatro últimas cifras sean iguales a las
                                cuatro últimas del premio mayor
                              </td>
                            </tr>
                            <tr>
                              <td><b>5</b></td>
                              <td>
                                <b>100 mil pesos</b><br />para los números cuyas cuatro últimas cifras sean iguales a
                                las cuatro últimas del segundo premio
                              </td>
                            </tr>
                            <tr>
                              <td><b>54</b></td>
                              <td>
                                <b>10 mil pesos</b><br />para los números cuyas tres últimas cifras sean iguales a las
                                tres últimas del premio mayor
                              </td>
                            </tr>
                            <tr>
                              <td><b>540</b></td>
                              <td>
                                <b>6 mil pesos</b><br />para los números cuyas dos últimas cifras sean iguales a las dos
                                últimas del premio mayor
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <p><b>*Tabla de premios por serie</b></p>
                        <p>En la lista de premios puedes identificar los premios por terminación con la letra “t”</p>
                      </li>
                      <li>
                        <h5>REINTEGROS</h5>
                        <p>
                          El reintegro se determina si el último dígito es igual al último dígito del premio mayor,
                          segundo y tercer premio
                        </p>
                        <p>En cada Sorteo Magno se reparten 11,394 reintegros de la siguiente manera:</p>
                        <ul>
                          <li>
                            <p>5,400 Reintegros por la última cifra del premio mayor.</p>
                          </li>
                          <li>
                            <p>5,994 Reintegros por la última cifra del segundo premio</p>
                          </li>
                        </ul>
                      </li>
                    </ol>
                    <h3>¿Qué debo considerar?</h3>
                    <p>
                      Un lote aleatorio de números de este sorteo se encuentra a la venta exclusivamente a través de
                      Medios Electrónicos.
                    </p>
                    <h3>Cómo saber si gané</h3>
                    <h5>A) Lista de Premios</h5>
                    <p>
                      La forma más común de revisar si fuiste ganador es a través de la lista de premios, misma que
                      podrás encontrar en los expendios de Lotería Nacional al día siguiente del sorteo, así como
                      también podrás consultarla de manera virtual en el
                      <a href="../../Mascarillas/ListasPremios">siguiente enlace</a>.
                    </p>
                    <h5>B) Verificador de cachitos</h5>
                    <p>
                      Esta es una herramienta sencilla, solo tienes que llenar la información solicitada en el siguiente
                      enlace. <a href="../../Home/BuscadorBoleto">verificador de premios</a>
                    </p>
                    <h5>C) Redes Sociales</h5>
                    <p>
                      Síguenos en nuestras redes sociales oficiales, ahí publicamos diariamente los resultados de todos
                      nuestros sorteos.
                    </p>
                  </div>
                </ion-col>
              </ion-row>
              <!-- Superior -->
              <ion-row *ngSwitchCase="'superior'">
                <ion-col size="12">
                  <div class="col-md-12">
                    <h3>¿Qué es el Sorteo Superior?</h3>
                    <p>
                      El Sorteo Superior se celebra los días viernes y participan 60 mil números (billetes) que van del
                      00001 al 60,000.
                    </p>
                    <p>
                      Se lleva a cabo en 2 series y ofrece un total de 51 millones 833 mil 200 pesos repartidos en
                      <b>12,896 premios</b>.
                    </p>
                    <h3>¿Cuánto vale un cachito?</h3>
                    <ul>
                      <li>
                        <p>Un <b>cachito</b> del Sorteo Superior tiene un costo de <b>40 pesos</b>.</p>
                      </li>
                      <li>
                        <p>El costo de <b>una serie</b> (20 cachitos) del Sorteo Superior es de <b>800 pesos</b>.</p>
                      </li>
                      <li>
                        <p>
                          El costo de las <b>dos series</b> (40 cachitos) del Sorteo Superior es de
                          <b>1 mil 600 pesos</b>.
                        </p>
                      </li>
                    </ul>
                    <h3>¿Cuánto puedo ganar con el Sorteo Superior?</h3>
                    <p>En el Sorteo Superior 1 de cada 5 gana.</p>
                    <ul>
                      <li>
                        <p>
                          Si adquiriste las <b>dos series</b> del Sorteo Superior puedes ganar el total del premio mayor
                          de <b>17 MILLONES DE PESOS.</b>
                        </p>
                      </li>
                      <li>
                        <p>
                          Si adquiriste <b>una serie</b> del Sorteo Superior puedes ganar hasta
                          <b>8.5 MILLONES DE PESOS.</b>
                        </p>
                      </li>
                      <li>
                        <p>
                          Si adquiriste un <b>Cachito</b> del Sorteo Superior puedes <b>ganar hasta 425 MIL PESOS</b>.
                        </p>
                      </li>
                    </ul>
                    <h3>Tipos de premios</h3>
                    <ol>
                      <li>
                        <h5>PREMIOS DIRECTOS</h5>
                        <p>Son los números que cantan los niños gritones durante la celebración del sorteo.</p>
                        <p>En el Sorteo Superior se entregan 700 premios directos.</p>
                        <p><b>Mismos que se reparten de la siguiente manera: </b></p>
                        <div class="table-responsive">
                          <table class="display table table-striped table-bordered text-center">
                            <thead class="align-middle">
                              <tr>
                                <th>CANTIDAD DE PREMIOS</th>
                                <th>PREMIOS POR SERIE</th>
                                <th>PREMIO POR DOS SERIES</th>
                              </tr>
                            </thead>
                            <tbody class="align-middle">
                              <tr>
                                <td><b>1</b></td>
                                <td>
                                  <h5>PREMIO MAYOR</h5>
                                  <br />$ 8.5 MILLONES
                                </td>
                                <td>
                                  <h5>PREMIO MAYOR</h5>
                                  <br />$ 17 MILLONES
                                </td>
                              </tr>
                              <tr>
                                <td><b>1</b></td>
                                <td>
                                  <h5>SEGUNDO PREMIO</h5>
                                  <br />$ 720 MIL
                                </td>
                                <td>
                                  <h5>SEGUNDO PREMIO</h5>
                                  <br />$1.4 MILLONES
                                </td>
                              </tr>
                              <tr>
                                <td><b>4</b></td>
                                <td>
                                  <h5>TERCER PREMIO</h5>
                                  <br />$ 137,500 MIL
                                </td>
                                <td>
                                  <h5>TERCER PREMIO</h5>
                                  <br />$ 275 MIL
                                </td>
                              </tr>
                              <tr>
                                <td><b>4</b></td>
                                <td>$ 72 MIL</td>
                                <td>$ 144 MIL</td>
                              </tr>
                              <tr>
                                <td><b>10</b></td>
                                <td>$ 45 MIL</td>
                                <td>$ 90 MIL</td>
                              </tr>
                              <tr>
                                <td><b>15</b></td>
                                <td>$ 36 MIL</td>
                                <td>$ 72 MIL</td>
                              </tr>
                              <tr>
                                <td><b>25</b></td>
                                <td>$ 21 MIL 600</td>
                                <td>$ 43 MIL</td>
                              </tr>
                              <tr>
                                <td><b>45</b></td>
                                <td>$14 mil 400</td>
                                <td>$ 28 mil 800</td>
                              </tr>
                              <tr>
                                <td><b>35</b></td>
                                <td>$7 MIL 200</td>
                                <td>$14 MIL 400</td>
                              </tr>
                              <tr>
                                <td><b>35</b></td>
                                <td>$5 MIL 760</td>
                                <td>$11 MIL 200</td>
                              </tr>
                              <tr>
                                <td><b>35</b></td>
                                <td>$5 MIL 040</td>
                                <td>$10 MIL 080</td>
                              </tr>
                              <tr>
                                <td><b>490</b></td>
                                <td>$3 MIL 600</td>
                                <td>$7 MIL 200</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <br />
                      </li>
                      <li>
                        <h5>PREMIOS POR APROXIMACIÓN</h5>
                        <p>
                          Son los 99 números que pertenecen a la misma centena de los números ganadores de los tres
                          premios principales.
                        </p>
                        <p>
                          En el Sorteo Superior se reparten <b>198 premios por aproximación</b> de la siguiente manera:
                        </p>
                        <div class="table-responsive">
                          <table class="display table table-bordered text-center">
                            <thead class="align-middle">
                              <tr>
                                <th>CANTIDAD DE PREMIOS</th>
                                <th>NÚMERO DE PREMIOS POR APROXIMACIÓN</th>
                                <th>MONTO</th>
                              </tr>
                            </thead>
                            <tbody class="align-middle">
                              <tr>
                                <td rowspan="2"><b>99</b></td>
                                <td><b>2</b></td>
                                <td>
                                  <b>60 mil pesos</b><br />cada uno, a los números anterior y posterior del premio mayor
                                </td>
                              </tr>
                              <tr>
                                <td><b>97</b></td>
                                <td>
                                  <b>2 mil 400 pesos</b><br />cada uno, para los números comprendidos en la centena del
                                  número que obtenga el premio mayor
                                </td>
                              </tr>
                              <tr>
                                <td rowspan="2"><b>99</b></td>
                                <td><b>2</b></td>
                                <td>
                                  <b>30 mil pesos</b><br />cada uno, a los números anterior y posterior del segundo
                                  premio
                                </td>
                              </tr>
                              <tr>
                                <td><b>97</b></td>
                                <td>
                                  <b>1 mil 800 pesos</b><br />cada uno, para los números comprendidos en la centena del
                                  número que obtenga el segundo premio
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <p>*Tabla de premios por serie</p>
                        <p>En la lista de premios podrán identificarlos con la letra “c”</p>
                      </li>
                      <li>
                        <h5>PREMIOS POR TERMINACIÓN</h5>
                        <p>
                          Son los números cuyas últimas 4, 3 o 2 cifras son iguales a los números que ganaron los dos
                          premios principales del sorteo.
                        </p>
                        <p>
                          En el Sorteo Superior se entregan en <b>604 premios por terminación</b> repartidos de la
                          siguiente manera:
                        </p>
                        <table class="display table table-bordered text-center">
                          <thead class="align-middle">
                            <tr>
                              <th>CANTIDAD DE PREMIOS</th>
                              <th>MONTO</th>
                            </tr>
                          </thead>
                          <tbody class="align-middle">
                            <tr>
                              <td><b>5</b></td>
                              <td>
                                <b>60 mil pesos</b><br />para los números cuyas últimas cuatro últimas cifras sean
                                iguales a las cuatro últimas del premio mayor
                              </td>
                            </tr>
                            <tr>
                              <td><b>5</b></td>
                              <td>
                                <b>30 mil pesos</b><br />para los números cuyas últimas cuatro últimas cifras sean
                                iguales a las cuatro últimas del segundo premio
                              </td>
                            </tr>
                            <tr>
                              <td><b>54</b></td>
                              <td>
                                <b>3 mil pesos</b><br />para los números cuyas últimas tres últimas cifras sean iguales
                                a las tres últimas del premio mayor
                              </td>
                            </tr>
                            <tr>
                              <td><b>540</b></td>
                              <td>
                                <b>1 mil 800 pesos</b><br />para los números cuyas últimas dos últimas cifras sean
                                iguales a las dos últimas del premio mayor
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <p>*Tabla de premios por serie</p>
                        <p>En la lista de premios puedes identificar los premios por terminación con la letra “t”</p>
                      </li>
                      <li>
                        <h5>REINTEGROS</h5>
                        <p>
                          El reintegro se determina si el último dígito es igual al último dígito del premio mayor,
                          segundo y tercer premio
                        </p>
                        <p>En cada Sorteo Superior se reparten 11,394 reintegros de la siguiente manera:</p>
                        <ul>
                          <li>
                            <p>5,400 Reintegros por la última cifra del premio mayor.</p>
                          </li>
                          <li>
                            <p>5,994 Reintegros por la última cifra del segundo premio</p>
                          </li>
                        </ul>
                      </li>
                    </ol>
                    <h3>¿Qué debo considerar?</h3>
                    <p>
                      Un lote aleatorio de números de este sorteo se encuentra a la venta exclusivamente a través de
                      Medios Electrónicos.
                    </p>
                    <h3>Cómo saber si gané</h3>
                    <h5>A) Lista de Premios</h5>
                    <p>
                      La forma más común de revisar si fuiste ganador es a través de la lista de premios, misma que
                      podrás encontrar en los expendios de Lotería Nacional al día siguiente del sorteo, así como
                      también podrás consultarla de manera virtual en el
                      <a href="../../Mascarillas/ListasPremios">siguiente enlace</a>.
                    </p>
                    <h5>B) Verificador de cachitos</h5>
                    <p>
                      Esta es una herramienta sencilla, solo tienes que llenar la información solicitada en el siguiente
                      enlace. <a href="../../Home/BuscadorBoleto">verificador de premios</a>
                    </p>
                    <h5>C) Redes Sociales</h5>
                    <p>
                      Síguenos en nuestras redes sociales oficiales, ahí publicamos diariamente los resultados de todos
                      nuestros sorteos.
                    </p>
                  </div>
                </ion-col>
              </ion-row>
              <!-- Mayor -->
              <ion-row *ngSwitchCase="'mayor'">
                <ion-col size="12">
                  <div class="col-md-12">
                    <h3>¿Qué es el Sorteo Mayor?</h3>
                    <p>
                      El Sorteo Mayor se celebra los días martes y participan 60 mil números (billetes) que van del
                      00001 al 60,000.
                    </p>
                    <p>
                      Se lleva a cabo en 3 series y ofrece un total de <b>66 MILLONES 99 MIL PESOS</b> repartidos en
                      <b>18,760 premios</b>.
                    </p>
                    <h3>¿Cuánto vale un cachito?</h3>
                    <ul>
                      <li>
                        <p><b>Un cachito</b> del Sorteo Mayor tiene un costo de 30 pesos.</p>
                      </li>
                      <li>
                        <p>El costo de <b>una serie</b> (20 cachitos) del Sorteo Mayor es de 600 pesos.</p>
                      </li>
                      <li>
                        <p>El costo de las <b>tres series</b> (60 cachitos) del Sorteo Mayor es de 1 mil 800 pesos.</p>
                      </li>
                    </ul>
                    <h3>¿Cuánto puedo ganar con el Sorteo Mayor?</h3>
                    <p>En el sorteo mayor 1 de cada 3 gana.</p>
                    <ul>
                      <li>
                        <p>
                          <b>Si adquiriste las tres</b> series del Sorteo Mayor cuyo costo es de 1 mil 800 pesos,
                          <b>puedes ganar el monto total del premio mayor de 21 millones de pesos.</b>
                        </p>
                      </li>
                      <li>
                        <p>
                          <b>Si adquiriste una serie</b> del Sorteo Mayor puedes <b>ganar hasta 7 millones de pesos</b>.
                        </p>
                      </li>
                      <li>
                        <p><b>Si adquiriste un Cachito</b> del Sorteo Mayor puedes <b>ganar es de 350 mil pesos</b>.</p>
                      </li>
                    </ul>
                    <h3>Tipos de premios</h3>
                    <ol>
                      <li>
                        <h5>PREMIOS DIRECTOS</h5>
                        <p>Son los números que cantan los niños gritones durante la celebración del sorteo.</p>
                        <p>En este sorteo se entregan 466 premios directos que</p>
                        <p><b>Repartidos de la siguiente manera:</b></p>
                        <div class="table-responsive">
                          <table class="table table-striped table-bordered text-center">
                            <thead class="align-middle">
                              <tr>
                                <th>CANTIDAD DE PREMIOS</th>
                                <th>PREMIO POR SERIE</th>
                                <th>PREMIO POR TRES SERIES</th>
                              </tr>
                            </thead>
                            <tbody class="align-middle">
                              <tr>
                                <td><b>1</b></td>
                                <td><b>¡Premio Mayor!</b> <br />$7 MILLONES</td>
                                <td><b>¡Premio Mayor!</b><br />$21 MILLONES</td>
                              </tr>
                              <tr>
                                <td><b>1</b></td>
                                <td><b>Segundo Premio</b><br />$850 MIL</td>
                                <td><b>Segundo Premio</b><br />$2.55 MILLONES</td>
                              </tr>
                              <tr>
                                <td><b>1</b></td>
                                <td><b>Tercer Premio</b><br />$300 MIL</td>
                                <td><b>Tercer Premio</b> <br />$900 MIL</td>
                              </tr>
                              <tr>
                                <td><b>4</b></td>
                                <td>$80 MIL</td>
                                <td>$240 MIL</td>
                              </tr>
                              <tr>
                                <td><b>5</b></td>
                                <td>$40 MIL</td>
                                <td>$120 MIL</td>
                              </tr>
                              <tr>
                                <td><b>10</b></td>
                                <td>$25 MIL</td>
                                <td>$75 MIL</td>
                              </tr>
                              <tr>
                                <td><b>14</b></td>
                                <td>$8 MIL</td>
                                <td>$24 MIL</td>
                              </tr>
                              <tr>
                                <td><b>430</b></td>
                                <td>$3 MIL</td>
                                <td>$9 MIL</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <br />
                      </li>
                      <li>
                        <h5>PREMIOS POR APROXIMACIÓN</h5>
                        <p>
                          Son los 99 números que pertenecen a la misma centena de los números ganadores de los tres
                          premios principales.
                        </p>
                        <p>En el Sorteo Mayor se reparten 297 premios por aproximación de la siguiente manera:</p>
                        <div class="table-responsive">
                          <table class="display table table-bordered text-center">
                            <thead class="align-middle">
                              <tr>
                                <th>CANTIDAD DE PREMIOS</th>
                                <th>NÚMERO DE PREMIOS POR APROXIMACIÓN</th>
                                <th>MONTO</th>
                              </tr>
                            </thead>
                            <tbody class="align-middle">
                              <tr>
                                <td rowspan="2"><b>99</b></td>
                                <td><b>2</b></td>
                                <td>
                                  <b>20 mil pesos</b> cada uno, a los números anterior y posterior del premio mayor
                                </td>
                              </tr>
                              <tr>
                                <td><b>97</b></td>
                                <td>
                                  <b>1 mil 600 pesos</b> cada uno, para los números comprendidos en la centena del
                                  número del premio mayor
                                </td>
                              </tr>
                              <tr>
                                <td rowspan="2"><b>99</b></td>
                                <td><b>2</b></td>
                                <td>
                                  <b>10 mil pesos</b> cada uno, a los números anterior y posterior del segundo premio
                                </td>
                              </tr>
                              <tr>
                                <td><b>97</b></td>
                                <td>
                                  <b>1 mil 200 pesos</b> cada uno, para los números comprendidos en la centena del
                                  número del segundo premio
                                </td>
                              </tr>
                              <tr>
                                <td rowspan="2"><b>99</b></td>
                                <td><b>2</b></td>
                                <td>
                                  <b>5 mil pesos</b> cada uno, a los números anterior y posterior del tercer premio
                                </td>
                              </tr>
                              <tr>
                                <td><b>97</b></td>
                                <td>
                                  <b>800 pesos</b> cada uno, para los números comprendidos en la centena del número del
                                  tercer premio
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <p>*Tabla de premios por serie</p>
                        <p>En la lista de premios podrán identificarlos con la letra “c”</p>
                      </li>
                      <li>
                        <h5>PREMIOS POR TERMINACIÓN</h5>
                        <p>
                          Son los números cuyas últimas 4, 3 o 2 cifras son iguales a los números que ganaron los dos
                          premios principales del sorteo.
                        </p>
                        <p>
                          En el Sorteo Mayor se entregan en <b>604 premios por terminación</b> repartidos de la
                          siguiente manera:
                        </p>
                        <table class="display table table-bordered text-center">
                          <thead class="align-middle">
                            <tr>
                              <th>CANTIDAD DE PREMIOS</th>
                              <th>MONTO</th>
                            </tr>
                          </thead>
                          <tbody class="align-middle">
                            <tr>
                              <td><b>5</b></td>
                              <td>
                                <b>12 mil pesos</b> para los números cuyas cuatro últimas cifras sean iguales a las
                                cuatro últimas del premio mayor
                              </td>
                            </tr>
                            <tr>
                              <td><b>5</b></td>
                              <td>
                                <b>8 mil pesos</b> para los números cuyas cuatro últimas cifras sean iguales a las
                                cuatro últimas del segundo premio
                              </td>
                            </tr>
                            <tr>
                              <td><b>54</b></td>
                              <td>
                                <b>2 mil pesos</b> para los números cuyas tres últimas cifras sean iguales a las tres
                                últimas del premio mayor (excluyendo las cuatro cifras)
                              </td>
                            </tr>
                            <tr>
                              <td><b>540</b></td>
                              <td>
                                <b>1 mil 200 pesos</b> para los números cuyas dos últimas cifras sean iguales a las dos
                                últimas del premio mayor (excluyendo las cuatro y tres cifras)
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <p>*Tabla de premios por serie</p>
                        <p>En la lista de premios puedes identificar los premios por terminación con la letra “t”.</p>
                      </li>
                      <li>
                        <h5>REINTEGROS</h5>
                        <p>El Sorteo Mayor se reparten 17,393 reintegros de la siguiente manera:</p>
                        <ul>
                          <li>
                            <p>5,400 Reintegros por la última cifra del premio mayor.</p>
                          </li>
                          <li>
                            <p>5,994 Reintegros por la última cifra del segundo premio</p>
                          </li>
                          <li>
                            <p>5,999 Reintegros por la última cifra del tercer premio</p>
                          </li>
                        </ul>
                      </li>
                    </ol>
                    <h3>¿Qué debo considerar?</h3>
                    <p>
                      Dos series del Sorteo Mayor son impresas y distribuidas de forma física, es decir, puedes
                      adquirirlas tradicionalmente a través de los expendios y vendedores ambulantes de billetes de
                      Lotería Nacional.
                    </p>
                    <p>
                      La tercera serie se encuentra a la venta exclusivamente a través de medios electrónicos y podrás
                      adquirirlos en <a href="https://www.alegrialoteria.com/">AlegríaLotería.com</a>
                    </p>
                    <h3>Cómo saber si gané</h3>
                    <h5>A) Lista de Premios</h5>
                    <p>
                      La forma más común de revisar si fuiste ganador es a través de la lista de premios, misma que
                      podrás encontrar en los expendios de Lotería Nacional al día siguiente del sorteo, así como
                      también podrás consultarla de manera virtual en el
                      <a href="../../Mascarillas/ListasPremios">siguiente enlace</a>.
                    </p>
                    <h5>B) Verificador de cachitos</h5>
                    <p>
                      Esta es una herramienta sencilla, solo tienes que llenar la información solicitada en el siguiente
                      enlace. <a href="../../Home/BuscadorBoleto">verificador de premios</a>
                    </p>
                    <h5>C) Redes Sociales</h5>
                    <p>
                      Síguenos en nuestras redes sociales oficiales, ahí publicamos diariamente los resultados de todos
                      nuestros sorteos.
                    </p>
                  </div>
                </ion-col>
              </ion-row>
              <!-- Gran Especial -->
              <ion-row *ngSwitchCase="'gran-especial'">
                <ion-col size="12">
                  <div [innerHTML]="htmlString"></div>
                </ion-col>
              </ion-row>
              <ion-row *ngSwitchDefault>
                <ion-col size="12"> No se encontraron las instrucciones solicitadas </ion-col>
              </ion-row>
            </ion-grid>

            <!--IGT-->
            <!-- MELATE -->
            <ion-grid *ngSwitchCase="'melate'" [ngSwitch]="type" fixed>
              <!-- Retro -->
              <ion-row *ngSwitchCase="'retro'">
                <ion-col size="12">
                  <div class="col-md-12">
                    <p>
                      <b>Melate Retro</b> es un juego que te regresa a los orígenes de Melate, desde aquel lejano
                      <b>19 de agosto de 1984</b>, cuando se estrenó por primera vez este sorteo.
                    </p>
                    <p>
                      Tiene una <b>Bolsa Mínima Garantizada</b> de <b>5 millones de pesos</b>, misma que se irá
                      acumulando en caso de que no haya ganadores.
                    </p>

                    <h3>¿CÓMO SE JUEGA?</h3>
                    <p>
                      Debes escoger una combinación posible seleccionando entre <b>6, 7, 8, 9 o hasta 10 números</b>,
                      más un <b>número adicional</b>, de un conjunto del 1 al 39.
                    </p>
                    <p>
                      La <b>jugada sencilla</b> tiene un costo de <b>$10 pesos</b>. El precio aumentará dependiendo la
                      cantidad de números seleccionados.
                    </p>
                    <p>
                      La urna de <b>Melate Retro</b> seleccionará aleatoriamente <b>7 esferas</b> con los números
                      ganadores: los primeros 6 son los <b>"números naturales"</b> y el séptimo es el
                      <b>número adicional</b>.
                    </p>

                    <h3>FECHAS DE LOS SORTEOS</h3>
                    <p>Este sorteo se realiza los <b>martes y sábados</b> de cada semana a las <b>21:00 hrs</b>.</p>
                    <p>Puedes seguir los sorteos a través de:</p>
                    <ul>
                      <li><b>Facebook:</b> Lotería Nacional – Sorteos Electrónicos</li>
                      <li><b>YouTube:</b> Lotería Nacional – Sorteos Electrónicos</li>
                    </ul>

                    <h3>¿CÓMO PARTICIPAR?</h3>
                    <p>
                      <b>Manual:</b> Elige los números directamente en la pantalla para formar tu combinación favorita.
                    </p>
                    <p>
                      <b>Aleatorio:</b> El sistema de CMillonario generará combinaciones al azar que puedes editar antes
                      de pagar.
                    </p>

                    <h3>¿CÓMO GANAR?</h3>
                    <p>
                      Para ganar, los números de tu boleto deberán coincidir con al menos
                      <b>un número natural y el adicional</b>. Mientras más números coincidan, mayor será tu premio.
                    </p>

                    <h4>Niveles de Premiación</h4>
                    <table border="1">
                      <tr>
                        <th>Lugar</th>
                        <th>Números Acertados</th>
                        <th>Monto del Premio</th>
                      </tr>
                      <tr>
                        <td>1° Lugar</td>
                        <td>6 números naturales</td>
                        <td>Bolsa Acumulada *</td>
                      </tr>
                      <tr>
                        <td>2° Lugar</td>
                        <td>5 números naturales y el adicional</td>
                        <td>Variable *</td>
                      </tr>
                      <tr>
                        <td>3° Lugar</td>
                        <td>5 números naturales</td>
                        <td>Variable *</td>
                      </tr>
                      <tr>
                        <td>4° Lugar</td>
                        <td>4 números naturales</td>
                        <td>Variable *</td>
                      </tr>
                      <tr>
                        <td>5° Lugar</td>
                        <td>3 números naturales</td>
                        <td>$21.50</td>
                      </tr>
                      <tr>
                        <td>6° Lugar</td>
                        <td>2 números naturales y el adicional</td>
                        <td>$16.13</td>
                      </tr>
                      <tr>
                        <td>7° Lugar</td>
                        <td>1 número natural y el adicional</td>
                        <td>$10.00</td>
                      </tr>
                    </table>
                    <p>
                      Los premios del 5º al 7º lugar son <b>fijos</b>. Del 1º al 4º lugar son <b>variables</b> y
                      dependen del monto acumulado y la cantidad de ganadores.
                    </p>

                    <h3>COSTOS</h3>
                    <p>El costo básico es de <b>$10 pesos</b> por cada combinación de 6 números naturales.</p>
                    <h4>Combinaciones Múltiples</h4>
                    <table border="1">
                      <tr>
                        <th>Cantidad de números</th>
                        <th>Combinaciones sencillas</th>
                        <th>Precio total</th>
                      </tr>
                      <tr>
                        <td>6</td>
                        <td>1</td>
                        <td>$10.00</td>
                      </tr>
                      <tr>
                        <td>7</td>
                        <td>7</td>
                        <td>$70.00</td>
                      </tr>
                      <tr>
                        <td>8</td>
                        <td>28</td>
                        <td>$280.00</td>
                      </tr>
                      <tr>
                        <td>9</td>
                        <td>84</td>
                        <td>$840.00</td>
                      </tr>
                      <tr>
                        <td>10</td>
                        <td>210</td>
                        <td>$2,100.00</td>
                      </tr>
                    </table>

                    <h3>IMPORTANTE</h3>
                    <p>Recuerda que tienes hasta <b>60 días naturales</b> para cobrar tu premio.</p>
                  </div>
                </ion-col>
              </ion-row>
              <!-- Non-retro -->
              <ion-row *ngSwitchCase="''">
                <ion-col size="12">
                  <div class="col-md-12">
                    <p>
                      <b>Melate</b> es el juego consentido de todos, pero como que una sola oportunidad para volverse
                      millonario a veces no es suficiente. Este sorteo siempre se lleva a cabo con una segunda y tercera
                      oportunidad, conocidas como <b>Revancha y Revanchita</b>.
                    </p>
                    <p>
                      Estos sorteos sin duda son atractivos para los participantes debido a que cada uno tiene sus
                      propias bolsas acumuladas que van aumentando después de cada sorteo, en caso de que no haya
                      ganadores.
                    </p>

                    <h3>¿CÓMO JUGAR?</h3>
                    <p>
                      El juego consiste en elegir una combinación posible seleccionando 6, 7, 8, 9 o hasta 10 números de
                      un conjunto del 1 al 56. El precio puede variar dependiendo la cantidad de números jugados.
                    </p>
                    <p>
                      En <b>Melate</b>, la máquina elige de manera aleatoria 7 esferas con los números ganadores: los
                      primeros 6 números son los "números naturales" y el séptimo es el número adicional. Melate tiene
                      una <b>Bolsa Mínima Garantizada</b> de <b>30 millones de pesos</b>, misma que se acumula si no hay
                      ganador del primer premio.
                    </p>

                    <h3>REVANCHA</h3>
                    <p>
                      Es tu segunda oportunidad para ganar, usando la misma combinación que elegiste en Melate. La urna
                      de Revancha selecciona 6 esferas al azar, sin número adicional. Su
                      <b>Bolsa Mínima Garantizada</b> es de <b>20 millones de pesos</b> y también se acumula si no hay
                      ganadores.
                    </p>

                    <h3>REVANCHITA</h3>
                    <p>
                      Es tu tercera y última oportunidad, también con tu misma combinación de Melate. La urna elige 6
                      esferas sin número adicional. Su <b>Bolsa Mínima Garantizada</b> es de
                      <b>10 millones de pesos</b> y se acumula si no hay ganadores.
                    </p>

                    <h3>FECHAS DE LOS SORTEOS</h3>
                    <p>
                      Los sorteos de Melate, Revancha y Revanchita se realizan juntos los días
                      <b>miércoles, viernes y domingos</b> a las <b>21:00 h</b>.
                    </p>
                    <p>Puedes seguir las transmisiones en vivo a través de:</p>
                    <ul>
                      <li><b>Facebook:</b> Lotería Nacional – Sorteos Electrónicos</li>
                      <li><b>YouTube:</b> Lotería Nacional – Sorteos Electrónicos</li>
                    </ul>

                    <h3>¿CÓMO PARTICIPAR?</h3>
                    <p><b>Manual:</b> Elige tu combinación preferida seleccionando los números directamente.</p>
                    <p>
                      <b>Aleatorio:</b> El sistema te sugiere combinaciones al azar que puedes modificar antes de pagar.
                    </p>

                    <h3>¿CÓMO GANAR?</h3>
                    <p>
                      Para ganar en cualquiera de estos sorteos, los números de tu combinación deben coincidir con al
                      menos <b>2 números naturales</b>. A mayor coincidencia, mayor será el premio.
                    </p>

                    <h4>Tabla de Premios - Melate</h4>
                    <table border="1">
                      <tr>
                        <th>Lugar</th>
                        <th>Números Acertados</th>
                        <th>Monto del Premio</th>
                      </tr>
                      <tr>
                        <td>1° Lugar</td>
                        <td>6 números naturales</td>
                        <td>Variable *</td>
                      </tr>
                      <tr>
                        <td>2° Lugar</td>
                        <td>5 números naturales y el adicional</td>
                        <td>Variable *</td>
                      </tr>
                      <tr>
                        <td>3° Lugar</td>
                        <td>5 números naturales</td>
                        <td>Variable *</td>
                      </tr>
                      <tr>
                        <td>4° Lugar</td>
                        <td>4 números naturales y el adicional</td>
                        <td>Variable *</td>
                      </tr>
                      <tr>
                        <td>5° Lugar</td>
                        <td>4 números naturales</td>
                        <td>Variable *</td>
                      </tr>
                      <tr>
                        <td>6° Lugar</td>
                        <td>3 números naturales y el adicional</td>
                        <td>$161.29</td>
                      </tr>
                      <tr>
                        <td>7° Lugar</td>
                        <td>3 números naturales</td>
                        <td>$43.01</td>
                      </tr>
                      <tr>
                        <td>8° Lugar</td>
                        <td>2 números naturales y el adicional</td>
                        <td>$32.25</td>
                      </tr>
                      <tr>
                        <td>9° Lugar</td>
                        <td>2 números naturales</td>
                        <td>$26.88</td>
                      </tr>
                    </table>
                    <p>
                      Los premios del 6º al 9º lugar son fijos. Del 1º al 5º son variables y dependen del monto
                      acumulado y número de ganadores.
                    </p>

                    <h4>Tabla de Premios - Revancha</h4>
                    <table border="1">
                      <tr>
                        <th>Lugar</th>
                        <th>Números Acertados</th>
                        <th>Monto del Premio</th>
                      </tr>
                      <tr>
                        <td>1° Lugar</td>
                        <td>6 números naturales</td>
                        <td>Variable *</td>
                      </tr>
                      <tr>
                        <td>2° Lugar</td>
                        <td>5 números naturales</td>
                        <td>Variable *</td>
                      </tr>
                      <tr>
                        <td>3° Lugar</td>
                        <td>4 números naturales</td>
                        <td>Variable *</td>
                      </tr>
                      <tr>
                        <td>4° Lugar</td>
                        <td>3 números naturales</td>
                        <td>$26.80</td>
                      </tr>
                      <tr>
                        <td>5° Lugar</td>
                        <td>2 números naturales</td>
                        <td>$10.75</td>
                      </tr>
                    </table>
                    <p>Para participar en Revancha es necesario participar en Melate.</p>

                    <h4>Revanchita</h4>
                    <p>
                      En <b>Revanchita</b> hay un solo lugar premiado: quien acierte los
                      <b>6 números naturales</b> ganará un premio <b>variable</b>, de acuerdo al monto acumulado.
                    </p>

                    <h3>COSTOS</h3>
                    <ul>
                      <li>Melate: $15 por combinación de 6 números.</li>
                      <li>Melate + Revancha: $25 por combinación.</li>
                      <li>Melate + Revancha + Revanchita: $30 por combinación.</li>
                    </ul>

                    <h3>IMPORTANTE</h3>
                    <p>Recuerda que tienes hasta <b>60 días naturales</b> para cobrar tu premio.</p>
                  </div>
                </ion-col>
              </ion-row>
              <ion-row *ngSwitchDefault>
                <ion-col size="12"> No se encontraron las instrucciones solicitadas </ion-col>
              </ion-row>
            </ion-grid>
            <!-- CHISPRAZO -->
            <ion-grid *ngSwitchCase="'chispazo'" [ngSwitch]="type" fixed>
              <ion-row *ngSwitchCase="''">
                <ion-col size="12">
                  <div class="col-md-12">
                    <h2>Chispazo</h2>
                    <p>
                      <b>Chispazo</b> es un sorteo de la familia de los Sorteos Electrónicos y es considerado el más
                      sencillo de ganar. No cuenta con una bolsa mínima garantizada, ya que su premiación depende de las
                      ventas acumuladas en cada sorteo.
                    </p>

                    <h3>¿CÓMO SE JUEGA?</h3>
                    <p>
                      El juego consiste en escoger una combinación posible de <b>5, 6 o hasta 7 números</b>, de un
                      conjunto del <b>1 al 28</b>. Basta con acertar <b>2 números</b> para ganar un premio.
                    </p>

                    <h3>FECHAS DE LOS SORTEOS</h3>
                    <p>Este sorteo se celebra <b>dos veces al día, todos los días</b>:</p>
                    <ul>
                      <li><b>Chispazo de las Tres:</b> 15:00 hrs.</li>
                      <li><b>Chispazo Clásico:</b> 21:00 hrs.</li>
                    </ul>
                    <p>Puedes seguir los sorteos en vivo a través de:</p>
                    <ul>
                      <li><b>Facebook:</b> Lotería Nacional – Sorteos Electrónicos</li>
                      <li><b>YouTube:</b> Lotería Nacional – Sorteos Electrónicos</li>
                    </ul>

                    <h3>¿CÓMO PARTICIPAR?</h3>
                    <p><b>Manual:</b> Elige tu combinación preferida seleccionando los números en la pantalla.</p>
                    <p>
                      <b>Aleatorio:</b> El sistema de CMillonario te mostrará combinaciones aleatorias que puedes
                      modificar antes de pagar.
                    </p>

                    <h3>¿CÓMO GANAR?</h3>
                    <p>
                      Para ganar, los números de tu boleto deben coincidir al menos con <b>2 números</b> de los
                      sorteados por la urna. Cuantos más números aciertes, mayor será el premio.
                    </p>
                    <p>
                      Si no hay ganadores para el primer lugar, la bolsa se reparte entre los ganadores del segundo
                      lugar, y así sucesivamente.
                    </p>

                    <h4>Tabla de Premios - Chispazo</h4>
                    <table border="1">
                      <tr>
                        <th>Categoría</th>
                        <th>Número de Aciertos</th>
                        <th>Monto del Premio</th>
                      </tr>
                      <tr>
                        <td>Primer lugar</td>
                        <td>5</td>
                        <td>Variable *</td>
                      </tr>
                      <tr>
                        <td>Segundo lugar</td>
                        <td>4</td>
                        <td>Variable *</td>
                      </tr>
                      <tr>
                        <td>Tercer lugar</td>
                        <td>3</td>
                        <td>Variable *</td>
                      </tr>
                      <tr>
                        <td>Cuarto lugar</td>
                        <td>2</td>
                        <td>$10.00</td>
                      </tr>
                    </table>
                    <p>
                      <b>Chispazo</b> no tiene bolsa mínima garantizada; su premiación se define por las ventas
                      acumuladas del sorteo.
                    </p>

                    <h3>COSTOS</h3>
                    <p>El costo de jugar una combinación sencilla (5 números) es de <b>$10 pesos</b>.</p>
                    <h4>Combinaciones Múltiples</h4>
                    <table border="1">
                      <tr>
                        <th>Números Comprados</th>
                        <th>Combinaciones</th>
                        <th>Precio</th>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>1</td>
                        <td>$10</td>
                      </tr>
                      <tr>
                        <td>6</td>
                        <td>6</td>
                        <td>$60</td>
                      </tr>
                      <tr>
                        <td>7</td>
                        <td>21</td>
                        <td>$210</td>
                      </tr>
                    </table>

                    <h3>IMPORTANTE</h3>
                    <p>Recuerda que tienes hasta <b>60 días naturales</b> para cobrar tu premio.</p>
                  </div>
                </ion-col>
              </ion-row>
              <ion-row *ngSwitchDefault>
                <ion-col size="12">No se encontraron las instrucciones solicitadas.</ion-col>
              </ion-row>
            </ion-grid>

            <!-- TRIS -->
            <ion-grid *ngSwitchCase="'tris'" [ngSwitch]="type" fixed>
              <ion-row *ngSwitchCase="''">
                <ion-col size="12">
                  <div class="col-md-12">
                    <h2>Tris</h2>
                    <p>
                      <b>Tris</b> es el sorteo numérico más accesible, en el que puedes decidir cuánto quieres ganar de
                      acuerdo con la modalidad que elijas y cuánto desees apostar.
                    </p>
                    <p>
                      Puedes jugarlo pagando desde sólo <b>$1 peso</b>, seleccionando <b>1, 2, 3, 4 o 5 dígitos</b>,
                      cada uno proveniente de un conjunto diferente de esferas del <b>0 al 9</b>.
                    </p>
                    <p>
                      Dependiendo de la modalidad que selecciones, tu oportunidad de ganar más dinero puede ir en
                      aumento. Las urnas de Tris elegirán <b>5 números al azar</b> para formar una cifra de 5 dígitos,
                      la cual deberá coincidir en <b>estricto orden</b> con los números de tu boleto o constancia de
                      participación para hacerte ganar muchísimo dinero.
                    </p>
                    <p>
                      ¡Con Tris puedes apostar desde 1 peso hasta 100 pesos! Mientras mayor sea tu apuesta, mayor será
                      el premio potencial.
                    </p>

                    <h3>¿CUÁNDO SE LLEVAN A CABO LOS SORTEOS?</h3>
                    <ul>
                      <li><b>Tris Medio día:</b> 13:00 hrs.</li>
                      <li><b>Tris de las Tres:</b> 15:00 hrs.</li>
                      <li><b>Tris Extra:</b> 17:00 hrs.</li>
                      <li><b>Tris de las Siete:</b> 19:00 hrs.</li>
                      <li><b>Tris Clásico:</b> 21:00 hrs.</li>
                    </ul>
                    <p>Puedes seguir los sorteos a través de:</p>

                    <ul>
                      <li><b>Facebook:</b> Lotería Nacional – Sorteos Electrónicos</li>
                      <li><b>YouTube:</b> Lotería Nacional – Sorteos Electrónicos</li>
                    </ul>

                    <h3>¿CÓMO PARTICIPAR?</h3>
                    <p><b>Manual:</b> Selecciona los números en la pantalla para formar tu combinación preferida.</p>
                    <p>
                      <b>Aleatorio:</b> El sistema de CMillonario te mostrará números al azar, que podrás modificar
                      antes de pagar.
                    </p>

                    <h3>¿CÓMO GANAR?</h3>
                    <p>
                      Las formas tradicionales de ganar con Tris dependen del tipo de apuesta y existen varias
                      modalidades:
                    </p>

                    <h4>1. Directas</h4>
                    <p>
                      <b>Directa de 5:</b> Acierta la combinación exacta de los cinco dígitos. Por cada peso invertido,
                      puedes ganar hasta <b>$50,000</b>.
                    </p>
                    <p>
                      <b>Directa de 4:</b> Acierta las últimas cuatro cifras (el primer dígito se descarta). Por cada
                      peso, puedes ganar hasta <b>$5,000</b>.
                    </p>
                    <p>
                      <b>Directa de 3:</b> Acierta las 3 últimas cifras. Por cada peso, puedes ganar hasta <b>$500</b>.
                    </p>
                    <p>
                      <b>Par Inicial:</b> Apuesta por la predicción de dos números, ya sea los iniciales o finales. Por
                      cada peso, puedes ganar hasta <b>$50</b>.
                    </p>
                    <p>
                      <b>Par Final:</b> Apuesta por la predicción de dos números, ya sea los iniciales o finales. Por
                      cada peso, puedes ganar hasta <b>$50</b>.
                    </p>
                    <p>
                      <b>Número Inicial:</b> Predice solo el primer o el último dígito. Si aciertas, ganas <b>$5</b> por
                      cada peso.
                    </p>
                    <p>
                      <b>Número Final:</b> Predice solo el primer o el último dígito. Si aciertas, ganas <b>$5</b> por
                      cada peso.
                    </p>

                    <h4>2. Combos Tris</h4>
                    <p>
                      Los combos te permiten incrementar tus posibilidades combinando varias apuestas con los mismos
                      números en las posiciones correspondientes a la Directa de 5.
                    </p>
                    <p><b>Combo 7:</b> Incluye los 7 juegos siguientes:</p>
                    <ol>
                      <li>Directa 5</li>
                      <li>Directa 4</li>
                      <li>Directa 3</li>
                      <li>Par Final</li>
                      <li>Par Inicial</li>
                      <li>Número Final</li>
                      <li>Número Inicial</li>
                    </ol>
                    <p>Si tu número y el sorteado coinciden en cualquiera de estas modalidades, serás ganador.</p>
                    <p>
                      <b>Combo 10:</b> Similar al Combo 7, pero aquí las apuestas mínimas para Directa 5, Número Final y
                      Número Inicial son de <b>2 pesos</b> cada una. Al aumentar el precio, también aumenta el premio
                      posible. Este combo ofrece 48 posibilidades de premio, con importes superiores a los del Combo 7.
                    </p>

                    <h4>3. Súper Candados</h4>
                    <p>
                      Los Súper Candados permiten participar en las apuestas de Directa de 4 o Directa de 3 sin que el
                      orden de tus números tenga que coincidir con el orden sorteado. Es decir, se generan todas las
                      combinaciones posibles con los números elegidos.
                    </p>

                    <h5>Súper Candados</h5>
                    <table border="1">
                      <tr>
                        <th>Modalidad</th>
                        <th>Apuesta</th>
                        <th>Importe</th>
                        <th>Premio Posible</th>
                      </tr>
                      <tr>
                        <td>Súper Candado 24 (Súper 24)</td>
                        <td>Todos los números diferentes</td>
                        <td>$24</td>
                        <td>$5,000</td>
                      </tr>
                      <tr>
                        <td>Súper Candado 12 (Súper 12)</td>
                        <td>Siendo dos números iguales</td>
                        <td>$12</td>
                        <td>$5,000</td>
                      </tr>
                      <tr>
                        <td>Súper Candado 6 (Súper 6)</td>
                        <td>Siendo dos pares de números iguales</td>
                        <td>$6</td>
                        <td>$5,000</td>
                      </tr>
                      <tr>
                        <td>Súper Candado 4 (Súper 4)</td>
                        <td>Siendo tres iguales y un número diferente</td>
                        <td>$4</td>
                        <td>$5,000</td>
                      </tr>
                    </table>

                    <p>Para marcar solo tres dígitos se realiza una apuesta Directa de 3:</p>

                    <table border="1">
                      <tr>
                        <th>Modalidad</th>
                        <th>Apuesta</th>
                        <th>Importe</th>
                        <th>Premio Posible</th>
                      </tr>
                      <tr>
                        <td>Súper Seis</td>
                        <td>Todos diferentes</td>
                        <td>$6</td>
                        <td>$500</td>
                      </tr>
                      <tr>
                        <td>Súper Tres</td>
                        <td>Siendo dos iguales</td>
                        <td>$3</td>
                        <td>$500</td>
                      </tr>
                    </table>

                    <h4>Niveles de Premiación y Costos</h4>
                    <p>
                      En Tris puedes apostar desde <b>$1</b> hasta <b>$100</b>, y los niveles de premiación varían según
                      la apuesta. A continuación, se muestra una tabla resumen:
                    </p>

                    <table border="1">
                      <tr>
                        <th>Modalidad</th>
                        <th>Ejemplo</th>
                        <th>Apuesta</th>
                        <th>Premio Posible</th>
                        <th>Probabilidad</th>
                      </tr>
                      <tr>
                        <td>Directa 5</td>
                        <td>97645</td>
                        <td>$1 a $100</td>
                        <td>$1 x $50,000</td>
                        <td>1 / 100,000</td>
                      </tr>
                      <tr>
                        <td>Directa 4</td>
                        <td>X7645</td>
                        <td>$1 a $100</td>
                        <td>$1 x $5,000</td>
                        <td>1 / 10,000</td>
                      </tr>
                      <tr>
                        <td>Directa 3</td>
                        <td>XX645</td>
                        <td>$1 a $100</td>
                        <td>$1 x $500</td>
                        <td>1 / 1,000</td>
                      </tr>
                      <tr>
                        <td>Par Inicial</td>
                        <td>45XXX</td>
                        <td>$1 a $100</td>
                        <td>$1 x $50</td>
                        <td>1 / 100</td>
                      </tr>
                      <tr>
                        <td>Par Final</td>
                        <td>XXX97</td>
                        <td>$1 a $100</td>
                        <td>$1 x $50</td>
                        <td>1 / 100</td>
                      </tr>
                      <tr>
                        <td>Número Inicial</td>
                        <td>5XXXX</td>
                        <td>$1 a $100</td>
                        <td>$1 x $5</td>
                        <td>1 / 10</td>
                      </tr>
                      <tr>
                        <td>Número Final</td>
                        <td>XXXX9</td>
                        <td>$1 a $100</td>
                        <td>$1 x $5</td>
                        <td>1 / 10</td>
                      </tr>
                      <tr>
                        <td>Súper Candado 24</td>
                        <td>X7645 (cuatro dígitos diferentes considerando hasta la unidad de millar)</td>
                        <td>$24 a $100</td>
                        <td>$24 x $5,000</td>
                        <td>1 / 417</td>
                      </tr>
                      <tr>
                        <td>Súper Candado 12</td>
                        <td>X7644 (dos dígitos diferentes y dos diferentes hasta la unidad de millar)</td>
                        <td>$12 a $100</td>
                        <td>$12 x $5,000</td>
                        <td>1 / 833</td>
                      </tr>
                      <tr>
                        <td>Súper Candado 6</td>
                        <td>X7744 (dos pares de dígitos iguales hasta la unidad de millar)</td>
                        <td>$6 a $100</td>
                        <td>$6 x $5,000</td>
                        <td>1 / 1,667</td>
                      </tr>
                      <tr>
                        <td>Súper Candado 4</td>
                        <td>X7444 (Tres dígitos iguales y uno diferente hasta la unidad de millar)</td>
                        <td>$4 a $100</td>
                        <td>$4 x $5,000</td>
                        <td>1 / 2,500</td>
                      </tr>
                      <tr>
                        <td>Súper Seis</td>
                        <td>XX745 (Tres números diferentes hasta la centena)</td>
                        <td>$6 a $100</td>
                        <td>$6 x $500</td>
                        <td>1 / 167</td>
                      </tr>
                      <tr>
                        <td>Súper Tres</td>
                        <td>XX744 (Dos números iguales y uno diferente hasta la centena)</td>
                        <td>$3 a $100</td>
                        <td>$3 x $500</td>
                        <td>1 / 333</td>
                      </tr>
                    </table>

                    <h3>Tris Multiplicador</h3>
                    <p>
                      Tris Multiplicador es un adicional que te permite multiplicar el monto de tu apuesta de Tris. Por
                      una cantidad adicional, igual o inferior a tu apuesta inicial, podrás multiplicar tu apuesta desde
                      <b>20 hasta 200,000 veces</b>, dependiendo de la modalidad que elijas.
                    </p>
                    <p>
                      <b>Puntos a considerar:</b>
                    </p>
                    <ul>
                      <li>Para activar Tris Multiplicador primero deberás jugar Tris.</li>
                      <li>La suma de tus apuestas de Tris y Tris Multiplicador no debe superar los <b>$100.00</b>.</li>
                      <li>La apuesta de Tris Multiplicador debe ser igual o menor a la apuesta de Tris.</li>
                      <li>El monto mínimo para jugar Tris es de <b>$1.00</b>.</li>
                      <li>El monto mínimo para jugar Multiplicador es de <b>$1.00</b>.</li>
                    </ul>
                    <p>
                      Recuerda que para ganar en Tris Multiplicador primero debes acertar los números ganadores de Tris.
                      Si la esfera seleccionada es <b>verde</b>, tu apuesta se multiplicará por al menos 20 y hasta
                      200,000 veces (según la modalidad y el monto apostado). Si la esfera es <b>blanca</b>, ganarás
                      únicamente tu premio de Tris y deberás seguir participando para tener la oportunidad de
                      multiplicar.
                    </p>
                    <p>
                      Puedes conocer más sobre los niveles de premiación en la página oficial de Lotería Nacional:
                      <a href="https://www.loterianacional.gob.mx/Tris/TrisMultiplicador" target="_blank"
                        >Tris Multiplicador</a
                      >
                    </p>

                    <h3>IMPORTANTE</h3>
                    <p>Recuerda que tienes hasta <b>60 días naturales</b> para cobrar tu premio.</p>
                  </div>
                </ion-col>
              </ion-row>
              <ion-row *ngSwitchDefault>
                <ion-col size="12">No se encontraron las instrucciones solicitadas.</ion-col>
              </ion-row>
            </ion-grid>

            <!-- PROGOL -->
            <ion-grid *ngSwitchCase="'progol'" [ngSwitch]="type" fixed>
              <ion-row *ngSwitchCase="''">
                <ion-col size="12">
                  <div class="col-md-12">
                    <h2>Progol</h2>
                    <p>
                      <b>Progol</b> es la quiniela que más paga en todo México y está conformada por
                      <b>14 partidos de fútbol</b>, nacionales e internacionales. Deberás predecir el resultado de cada
                      encuentro: <b>Local, Empate o Visita</b>.
                    </p>
                    <p>
                      El resultado oficial es el obtenido durante el <b>tiempo reglamentario</b>, excluyendo tiempos
                      extras o penales.
                    </p>
                    <p>
                      La <b>bolsa mínima garantizada</b> es de <b>5 millones de pesos</b> y se acumula si no hay ganador
                      del primer lugar.
                    </p>

                    <h3>PROGOL REVANCHA</h3>
                    <p>
                      <b>Progol Revancha</b> es una segunda oportunidad para ganar. Es un juego complementario en el que
                      deberás predecir los resultados de <b>7 partidos</b> nacionales o internacionales.
                    </p>
                    <p>Para jugar la Revancha, es necesario participar primero en <b>Progol</b>.</p>

                    <h3>¿CUÁNDO SE REALIZAN LOS CONCURSOS?</h3>
                    <p>Se celebran de acuerdo con las fechas publicadas en la <b>Quiniela de la Semana</b>.</p>

                    <h3>¿CÓMO PARTICIPAR?</h3>
                    <p><b>Manual:</b> Marca tus predicciones directamente en el volante (L, E o V).</p>
                    <p>
                      <b>Aleatorio:</b> El sistema de CMillonario generará combinaciones al azar que puedes modificar
                      antes de pagar.
                    </p>

                    <h3>NIVELES DE PREMIACIÓN</h3>
                    <p>
                      <b>Progol</b> cuenta con <b>5 niveles de premiación</b>. Si no hay ganador del primer lugar, la
                      bolsa se acumula. Los premios para el 2°, 3°, 4° y 5° lugar siempre se reparten:
                    </p>
                    <ul>
                      <li>Si nadie acierta a 13 resultados, el 2° lugar se reparte entre quienes acierten 12.</li>
                      <li>Y así sucesivamente.</li>
                    </ul>
                    <p>
                      En <b>Progol Revancha</b>, existe una única categoría de premiación. El premio se reparte entre
                      las quinielas con mayor número de aciertos:
                    </p>
                    <ul>
                      <li>Si nadie acierta los 7 resultados, se reparte entre quienes acierten 6.</li>
                      <li>Y así sucesivamente.</li>
                    </ul>

                    <h3>PRECIO</h3>
                    <ul>
                      <li><b>Progol:</b> $15 pesos por quiniela sencilla.</li>
                      <li><b>Progol Revancha:</b> $5 pesos por quiniela sencilla.</li>
                      <li><b>Progol + Revancha:</b> $20 pesos por quiniela sencilla.</li>
                    </ul>

                    <h3>QUINIELAS MÚLTIPLES</h3>
                    <p>Las <b>Quinielas Múltiples</b> incrementan tus posibilidades de ganar.</p>
                    <h5><b>Formas de jugar Quinielas múltiples:</b></h5>
                    <p>
                      <b>Quiniela doble: </b>Consiste en seleccionar 2 pronósticos de estas tres opciones: local-empate,
                      empate-visita y local-visita. Podrás jugar hasta 8 quinielas dobles por quiniela. Consulta la
                      tabla de abajo para conocer su precio.
                    </p>
                    <p>
                      <b>Quiniela triple:</b> Asegura tu casillero seleccionando los tres pronósticos (Local, Empate y
                      Visita). Podrás jugar hasta 5 triples por cada quiniela.
                    </p>
                    <p>
                      <b>Quiniela Combinada:</b> También puedes combinar tus predicciones con un máximo de 2 dobles y 4
                      triples.
                    </p>
                    <p>
                      La <b>Revancha</b> del Progol también te permite hacer Múltiples apuestas, en donde el máximo
                      serán tres dobles y dos triples. Podrás revisar las tablas de quinielas multiples y sus costos en
                    </p>
                    <p></p>
                    <a href="https://www.loterianacional.gob.mx/Progol/Coperacha"
                      >https://www.loterianacional.gob.mx/Progol/Coperacha</a
                    >
                    <h3>IMPORTANTE</h3>
                    <p>Recuerda que tienes hasta <b>60 días naturales</b> para cobrar tu premio.</p>
                  </div>
                </ion-col>
              </ion-row>
              <ion-row *ngSwitchDefault>
                <ion-col size="12">No se encontraron las instrucciones solicitadas.</ion-col>
              </ion-row>
            </ion-grid>

            <ion-grid *ngSwitchCase="'progol'" [ngSwitch]="type" fixed>
              <ion-row *ngSwitchCase="'media-semana'">
                <ion-col size="12">
                  <div class="col-md-12">
                    <h2>Progol ½ Semana</h2>
                    <p>
                      <b>Progol ½ Semana</b> es una quiniela de <b>9 partidos de fútbol soccer</b> nacional e
                      internacional en la que deberás predecir el resultado de cada encuentro:
                      <b>Local, Empate o Visita</b>.
                    </p>
                    <p>
                      El resultado oficial se considera únicamente el del <b>tiempo reglamentario</b>, sin incluir
                      tiempos extras o penales.
                    </p>

                    <h3>¿CUÁNDO SE REALIZAN LOS CONCURSOS?</h3>
                    <p>Se celebran de acuerdo con las fechas publicadas en la <b>Quiniela de la Semana</b>.</p>

                    <h3>¿CÓMO PARTICIPAR?</h3>
                    <p><b>Manual:</b> Marca tus predicciones directamente en el volante (L, E o V).</p>
                    <p>
                      <b>Aleatorio:</b> El sistema de CMillonario generará combinaciones al azar que puedes ajustar
                      antes de pagar.
                    </p>

                    <h3>¿CÓMO GANAR?</h3>
                    <p>
                      En <b>Progol ½ Semana siempre hay ganador</b>. El premio se reparte entre las quinielas con mayor
                      número de aciertos:
                    </p>
                    <ul>
                      <li>Si hay quinielas con 9 aciertos, ganan el 1er lugar.</li>
                      <li>Si no hay con 9, se reparte entre quienes acierten 8.</li>
                      <li>Y así sucesivamente hasta asegurar ganadores.</li>
                    </ul>

                    <h3>PRECIO</h3>
                    <p>La quiniela sencilla de <b>Progol ½ Semana</b> tiene un costo de <b>$15 pesos</b>.</p>
                    <p>También puedes aprender a jugar con <b>combinaciones múltiples</b> o <b>coperachas</b>.</p>

                    <h3>IMPORTANTE</h3>
                    <p>Recuerda que tienes hasta <b>60 días naturales</b> para cobrar tu premio.</p>
                  </div>
                </ion-col>
              </ion-row>
              <ion-row *ngSwitchDefault>
                <ion-col size="12">No se encontraron las instrucciones solicitadas.</ion-col>
              </ion-row>
            </ion-grid>

            <!-- GANA-GATO -->
            <ion-grid *ngSwitchCase="'gana-gato'" [ngSwitch]="type" fixed>
              <ion-row *ngSwitchCase="''">
                <ion-col size="12">
                  <div class="col-md-12">
                    <h2>Gana Gato</h2>
                    <p>
                      <b>Gana Gato</b> es un divertido sorteo numérico inspirado en el popular juego del "Gato", donde
                      las probabilidades de ganar son muchas.
                    </p>
                    <p>
                      Cada tablero cuenta con ocho recuadros en los que deberás seleccionar un número del <b>1 al 5</b>.
                      El recuadro central es un <b>comodín</b>, marcado con el logotipo de Gana Gato, y ayuda a formar
                      líneas ganadoras.
                    </p>
                    <p>
                      Solo necesitas formar <b>una línea</b> para ganar. Las líneas pueden ser horizontales, verticales
                      o diagonales.
                    </p>
                    <p>La <b>Bolsa Mínima Garantizada</b> es de <b>$300,000 pesos</b>.</p>

                    <h3>¿CUÁNDO SE LLEVAN A CABO LOS SORTEOS?</h3>
                    <ul>
                      <li><b>Martes</b></li>
                      <li><b>Jueves</b></li>
                      <li><b>Sábados</b></li>
                    </ul>
                    <p>Horario: 21:00 hrs.</p>
                    <p>Puedes ver los sorteos a través de:</p>
                    <ul>
                      <li><b>Facebook:</b> Lotería Nacional – Sorteos Electrónicos</li>
                      <li><b>YouTube:</b> Lotería Nacional – Sorteos Electrónicos</li>
                    </ul>
                    <h3>¿CÓMO PARTICIPAR?</h3>
                    <p><b>Manual:</b> Selecciona tus números directamente en pantalla.</p>
                    <p>
                      <b>Aleatorio:</b> El sistema de CMillonario te mostrará combinaciones aleatorias que puedes
                      modificar antes de pagar.
                    </p>

                    <h3>¿CÓMO GANAR?</h3>
                    <p>
                      Para ganar, al menos <b>3 números</b> seleccionados deben coincidir con los del sorteo, y formar
                      una <b>línea recta</b> (horizontal, vertical o diagonal) de 3 casillas consecutivas.
                    </p>
                    <p>
                      El recuadro central actúa como <b>comodín</b> para ayudarte a formar más líneas y aumentar tus
                      posibilidades de ganar.
                    </p>

                    <h4>Categorías de Premiación</h4>
                    <table border="1">
                      <tr>
                        <th>Lugar</th>
                        <th>Número de Líneas</th>
                      </tr>
                      <tr>
                        <td>1° Lugar</td>
                        <td>7 u 8 líneas</td>
                      </tr>
                      <tr>
                        <td>2° Lugar</td>
                        <td>6 líneas</td>
                      </tr>
                      <tr>
                        <td>3° Lugar</td>
                        <td>5 líneas</td>
                      </tr>
                      <tr>
                        <td>4° Lugar</td>
                        <td>4 líneas</td>
                      </tr>
                      <tr>
                        <td>5° Lugar</td>
                        <td>3 líneas</td>
                      </tr>
                      <tr>
                        <td>6° Lugar</td>
                        <td>2 líneas</td>
                      </tr>
                      <tr>
                        <td>7° Lugar</td>
                        <td>1 línea</td>
                      </tr>
                    </table>

                    <h3>COSTO</h3>
                    <p>El precio por apuesta es de <b>$10 pesos</b>.</p>

                    <h3>IMPORTANTE</h3>
                    <p>Recuerda que tienes hasta <b>60 días naturales</b> para cobrar tu premio.</p>
                  </div>
                </ion-col>
              </ion-row>
              <ion-row *ngSwitchDefault>
                <ion-col size="12">No se encontraron las instrucciones solicitadas.</ion-col>
              </ion-row>
            </ion-grid>

            <!-- Protouch -->
            <ion-grid *ngSwitchCase="'protouch'" [ngSwitch]="type" fixed>
              <ion-row *ngSwitchCase="''">
                <ion-col size="12">
                  <div class="col-md-12">
                    <p>
                      <b>Protouch</b> es una quiniela de <b>13 partidos de fútbol americano</b> (NFL o nivel colegial),
                      donde deberás predecir el resultado de cada encuentro como: <b>Local</b>, <b>Diferencia</b> (hasta
                      6 puntos de diferencia, a favor de cualquier equipo) o <b>Visita</b>.
                    </p>

                    <h3>¿CUÁNDO SE REALIZAN LOS CONCURSOS?</h3>
                    <p>
                      Los concursos se llevan a cabo según las fechas establecidas en cada <b>Quiniela de la Semana</b>.
                    </p>

                    <h3>¿CÓMO PARTICIPAR?</h3>
                    <p><b>Manual:</b> Marca tus predicciones (Local, Diferencia, Visita) directamente en el volante.</p>
                    <p>
                      <b>Aleatorio:</b> El sistema de CMillonario generará combinaciones al azar que puedes modificar
                      antes de pagar.
                    </p>

                    <h3>¿CÓMO GANAR?</h3>
                    <p>
                      Para ganar la <b>Bolsa Inicial Mínima Garantizada</b> debes acertar los resultados de
                      <b>todos los encuentros</b> de la quiniela.
                    </p>
                    <p>
                      Además, al participar en la quiniela sencilla, también entras en <b>Protouch Inicial</b>, donde
                      debes predecir:
                    </p>

                    <ul>
                      <li>Qué equipo anotará el <b>primer touchdown</b></li>
                      <li>En qué <b>cuarto</b> se anotará</li>
                      <li>O si <b>no habrá touchdown</b> en el partido</li>
                    </ul>

                    <h3>NIVELES DE PREMIACIÓN</h3>
                    <ul>
                      <li><b>1° lugar:</b> 13 aciertos (si no hay ganador, la bolsa se acumula)</li>
                      <li><b>2° lugar:</b> 12 aciertos</li>
                      <li><b>3° lugar:</b> 11 aciertos</li>
                    </ul>
                    <p>
                      Los premios del <b>2° y 3° lugar siempre se reparten</b>. Si nadie acierta al 1° lugar, la bolsa
                      acumulada pasa al siguiente concurso.
                    </p>
                    <p>
                      <b>Protouch Inicial</b> tiene <b>una única categoría</b> de premiación, y si no hay ganador, la
                      bolsa también se acumula.
                    </p>

                    <h3>PRECIO</h3>
                    <p>La <b>quiniela sencilla</b> de Protouch tiene un precio de <b>$10 pesos</b>.</p>
                    <p>Puedes aprender a jugar con <b>Combinaciones Múltiples</b> para aumentar tus oportunidades.</p>

                    <h3>IMPORTANTE</h3>
                    <p>Recuerda que tienes hasta <b>60 días naturales</b> para cobrar tu premio.</p>
                  </div>
                </ion-col>
              </ion-row>
              <ion-row *ngSwitchDefault>
                <ion-col size="12">No se encontraron las instrucciones solicitadas.</ion-col>
              </ion-row>
            </ion-grid>

            <!-- PRONO-SPORTS -->
            <ion-grid *ngSwitchCase="'prono-sports'" [ngSwitch]="type" fixed>
              <ion-row *ngSwitchCase="''">
                <ion-col size="12">
                  <div class="col-md-12">
                    <h2>Pronosports</h2>
                    <p>
                      <b>Pronosports</b> es el concurso de Lotería Nacional con el cual
                      <b>¡tú decides con quién ganar!</b>
                    </p>
                    <p>
                      Es un sistema de apuestas de <b>dividendo fijo (momios)</b>, donde puedes hacer pronósticos sobre
                      resultados de partidos de <b>fútbol soccer, básquetbol, béisbol y fútbol americano</b>.
                    </p>

                    <h3>¿CÓMO PARTICIPAR?</h3>
                    <p>
                      En cada concurso puedes visualizar hasta <b>300 encuentros deportivos</b> para armar tu propia
                      quiniela, seleccionando de <b>3 a 8 partidos</b>, sin importar el deporte. Solo puedes participar
                      en una modalidad de apuesta por encuentro dentro de cada constancia.
                    </p>
                    <p>
                      También puedes apostar a los <b>“partidos únicos”</b>, señalados con una <b>U en rojo</b> en la
                      Lista de Juegos, donde se permite apostar a un solo encuentro.
                    </p>
                    <p>
                      La <b>Lista de Juegos</b> se actualiza cada semana, con vigencia de <b>jueves a miércoles</b>.
                      Para ganar, deberás acertar <b>todos los resultados</b> de los partidos seleccionados.
                    </p>

                    <h3>TIPOS DE APUESTA</h3>
                    <ul>
                      <li>
                        <b>Resultado Final (RF):</b> Pronostica el resultado final (Local, Empate o Visita). <br />En
                        fútbol se toma en cuenta solo el tiempo reglamentario. <br />En básquetbol, béisbol y fútbol
                        americano se considera el resultado con tiempos extras.
                      </li>
                      <li>
                        <b>Medio Tiempo (MT):</b> Pronóstico del marcador al final de la primera mitad. En béisbol se
                        considera como primera mitad las <b>primeras cinco entradas</b>.
                      </li>
                      <li>
                        <b>Doble Oportunidad (DO):</b> Solo para fútbol. Selecciona dos posibles resultados del partido:
                        <ul>
                          <li><b>LE:</b> Local o Empate</li>
                          <li><b>LV:</b> Local o Visita</li>
                          <li><b>EV:</b> Empate o Visita</li>
                        </ul>
                      </li>
                      <li>
                        <b>Total de Goles (TG):</b> Solo para fútbol. Pronóstico del total de goles anotados:
                        <ul>
                          <li>0–1 goles</li>
                          <li>2–3 goles</li>
                          <li>4 o más goles</li>
                        </ul>
                      </li>
                      <li>
                        <b>Ambos equipos anotan (AA):</b> Solo para fútbol. Pronostica si ambos equipos anotarán al
                        menos un gol durante el tiempo reglamentario.
                      </li>
                    </ul>

                    <p>
                      <b>IMPORTANTE:</b> Solo puedes elegir <b>un tipo de apuesta por partido</b>. Si seleccionas más de
                      una, el sistema lo declarará nulo automáticamente.
                    </p>

                    <h3>PRECIOS</h3>
                    <p>Puedes elegir el monto de tu apuesta desde <b>$10 pesos</b> hasta <b>$2,000 pesos</b>.</p>

                    <h3>RESULTADOS Y PREMIOS</h3>
                    <p>
                      Para ganar, necesitas <b>acertar todos los pronósticos</b> de los encuentros seleccionados. El
                      monto del premio dependerá de los <b>momios establecidos</b> en cada juego.
                    </p>

                    <h3>REGLAS Y CONDICIONES</h3>
                    <p>
                      Puedes consultar las reglas completas del concurso en el sitio oficial:
                      <a href="https://www.loterianacional.gob.mx/PronoSports/Reglas" target="_blank"
                        >https://www.loterianacional.gob.mx/PronoSports/Reglas</a
                      >
                    </p>

                    <h3>IMPORTANTE</h3>
                    <p>Recuerda que tienes hasta <b>60 días naturales</b> para cobrar tu premio.</p>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
            <ion-grid *ngSwitchDefault fixed>
              <ion-row>
                <ion-col size="6">Parece que no encontre las instrucciones solicitadas</ion-col>
              </ion-row>
            </ion-grid>
          </div>
        </ion-card>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <ion-item lines="none" class="ion-margin-bottom">
          <ion-label>¿Te fue útil la información?</ion-label>
          <ion-button (click)="sendUtil(true)">
            <ion-icon slot="end" name="thumbs-up-outline"></ion-icon>
          </ion-button>

          <ion-button (click)="sendUtil(false)">
            <ion-icon slot="end" name="thumbs-down-outline"></ion-icon>
          </ion-button>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row class="ion-margin-top ion-padding-top">
      <ion-col size="12" class="ion-padding-bottom">
        <h2 class="ion-text-center">
          <ion-icon src="./assets/icons/pg18.svg" color="primary"></ion-icon>
        </h2>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
